import {css} from "lit-element/lit-element.js";
export default css`@charset "UTF-8";
/*
 * INSTRUCTIONS:
 * - variables cannot reference themselves
 * - variables may reference other variables, but must ALWAYS have an explicit default fallback (since that variable may not exist in reality).
 * - The fallback value should be the same as any referenced variable
 */
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]) {
  box-sizing: border-box;
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *::before, :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *::after {
  box-sizing: inherit;
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]):where(a), :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *:where(a) {
  text-decoration: var(--wy-link-decoration, none);
  color: var(--wy-link, var(--wy-primary-40, #006399));
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]):where(a):hover, :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *:where(a):hover {
  text-decoration: var(--wy-link-hover-decoration, unset);
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]):where(a):where(:not([href]):not([class])), :where(:host, :host > *, [class^=wy-], [class*=" wy-"]):where(a):where(:not([href]):not([class])):hover, :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *:where(a):where(:not([href]):not([class])), :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *:where(a):where(:not([href]):not([class])):hover {
  text-decoration: none;
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]):where(p), :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *:where(p) {
  margin-top: 0;
  margin-bottom: 1rem;
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]):where(label), :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *:where(label) {
  cursor: inherit;
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"])[hidden], :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *[hidden] {
  display: none !important;
}
:where(:host, :host > *, [class^=wy-], [class*=" wy-"]):where([role=button]), :where(:host, :host > *, [class^=wy-], [class*=" wy-"]) *:where([role=button]) {
  cursor: pointer;
}

.wy-scroll-y {
  overflow-y: auto;
  touch-action: pan-y, pan-x;
  will-change: scroll-position, opacity;
  backface-visibility: hidden;
  max-height: 100%;
  scroll-padding-top: var(--wy-scrollbar-adjust-top, 0);
  scroll-padding-bottom: var(--wy-scrollbar-adjust-bottom, 0);
}
.wy-scroll-y:not(body) {
  -webkit-overflow-scrolling: touch;
}
.wy-scroll-y:not(.wy-scroll-x) {
  overflow-x: hidden;
  touch-action: pan-y;
}

.wy-scroll-x {
  overflow-x: auto;
  touch-action: pan-y, pan-x;
  will-change: scroll-position, opacity;
  backface-visibility: hidden;
  max-width: 100%;
}
.wy-scroll-x:not(.wy-scroll-y) {
  overflow-y: hidden;
  touch-action: pan-x;
}

.wy-scrollbars.wy-scroll-y, .wy-scrollbars .wy-scroll-y {
  scrollbar-width: thin;
  scrollbar-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e)) transparent;
}
@supports (overflow-y: overlay) {
  .wy-scrollbars.wy-scroll-y, .wy-scrollbars .wy-scroll-y {
    overflow-y: overlay;
  }
}
.wy-scrollbars.wy-scroll-y::-webkit-scrollbar, .wy-scrollbars .wy-scroll-y::-webkit-scrollbar {
  height: 0.625rem;
  width: 0.625rem;
  background: transparent;
  z-index: 999;
}
.wy-scrollbars.wy-scroll-y::-webkit-scrollbar-track, .wy-scrollbars .wy-scroll-y::-webkit-scrollbar-track {
  background: transparent;
}
.wy-scrollbars.wy-scroll-y::-webkit-scrollbar-thumb, .wy-scrollbars .wy-scroll-y::-webkit-scrollbar-thumb {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  border: 0.125rem solid transparent;
  border-radius: 0.5rem;
  background-clip: padding-box;
  opacity: 75%;
}
.wy-scrollbars.wy-scroll-y::-webkit-scrollbar-thumb:hover, .wy-scrollbars .wy-scroll-y::-webkit-scrollbar-thumb:hover {
  background-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  opacity: 75%;
}
.wy-scrollbars.wy-scroll-y::-webkit-scrollbar-thumb:window-inactive, .wy-scrollbars .wy-scroll-y::-webkit-scrollbar-thumb:window-inactive {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  opacity: 50%;
}
.wy-scrollbars.wy-scroll-y::-webkit-scrollbar-button:vertical:start:single-button, .wy-scrollbars .wy-scroll-y::-webkit-scrollbar-button:vertical:start:single-button {
  height: var(--wy-scrollbar-adjust-top, 0);
}
.wy-scrollbars.wy-scroll-y::-webkit-scrollbar-button:vertical:end:single-button, .wy-scrollbars .wy-scroll-y::-webkit-scrollbar-button:vertical:end:single-button {
  height: var(--wy-scrollbar-adjust-bottom, 0);
}

.wy-block-scroll {
  overflow: hidden !important;
}

.wy-scrollbar-detection {
  position: fixed;
  top: 0;
  left: 0;
  width: 8rem;
  height: 8rem;
  overflow: scroll;
  z-index: -99999;
  pointer-events: none;
  visibility: hidden;
}

.wy-appbars {
  backface-visibility: hidden;
  --wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  background-color: var(--wy-component-background-color);
  box-shadow: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0px -1px 0px 0px inset;
}
@supports (position: sticky) {
  .wy-appbars {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@supports (backdrop-filter: blur(0.5rem)) {
  .wy-appbars {
    backdrop-filter: blur(0.5rem);
  }
  .wy-appbars > .wy-appbar {
    backdrop-filter: none;
  }
}
.wy-appbars > .wy-appbar, .wy-appbars > .wy-toolbar {
  background-color: transparent;
  box-shadow: none;
}

.wy-appbar {
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  --wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  display: grid;
  align-items: center;
  justify-content: space-between;
  justify-items: center;
  height: var(--wy-appbar-height, 3rem);
  padding: 0.25rem;
  flex: 0 0 var(--wy-appbar-height, 3rem);
  grid-template-columns: minmax(2.5rem, max-content) minmax(0, max-content) minmax(2.5rem, max-content);
  column-gap: 0.5rem;
  line-height: var(--wy-line-height-base, );
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  box-shadow: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0px -1px 0px 0px inset;
}
.wy-appbar .wy-badge {
  align-self: center;
}
.wy-appbar .wy-button {
  max-height: 2.5rem;
}

.wy-appbar-buttons, .wy-toolbar-buttons {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
}

.wy-toolbar-buttons-last {
  margin-inline-start: auto;
}

.wy-appbar-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  color: inherit !important;
  user-select: none;
}
.wy-appbar-text a {
  color: inherit;
}
.wy-appbar-text a:hover {
  color: inherit;
}

.wy-appbar-text-trashed {
  text-decoration: line-through;
}

.wy-toolbars-bottom {
  position: absolute;
  z-index: 1030;
  bottom: calc(var(--wy-footerbar-height, 4rem) / 2);
  left: 0;
  right: 0;
  min-height: var(--wy-appbar-height, 3rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
}

.wy-toolbar {
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  --wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  justify-items: center;
  min-height: var(--wy-appbar-height, 3rem);
  padding: 0.25rem;
  flex: 1 0 var(--wy-appbar-height, 3rem);
  column-gap: 0.25rem;
  line-height: var(--wy-line-height-base, );
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  box-shadow: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0px -1px 0px 0px inset;
}

.wy-toolbar-center {
  margin: 0 auto;
  border-radius: var(--wy-border-radius, 0.5rem);
}
.wy-toolbar-center .wy-input {
  text-align: center;
}

.wy-toolbar-text {
  margin-left: 0.25rem;
}

.wy-footerbars {
  padding-bottom: var(--wy-footerbar-height, 4rem);
}
.wy-footerbars > .wy-toolbar {
  box-shadow: none;
}

.wy-footerbar {
  --wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1020;
}
.wy-footerbar::after {
  content: "";
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  box-shadow: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0px 1px 0px 0px inset;
  position: absolute;
  width: 100vw;
  left: 0;
  bottom: 0;
  height: 100%;
  z-index: -1;
  backface-visibility: hidden;
}
@supports (backdrop-filter: blur(0.5rem)) {
  .wy-footerbar::after {
    backdrop-filter: blur(0.5rem);
  }
}
.wy-footerbar .wy-buttons {
  flex-direction: row-reverse;
}
.wy-footerbar .wy-buttons > :not(:last-child) {
  margin: 0 0 0 0.5rem;
}

.wy-footerbar-sticky {
  position: sticky;
}

.wy-footerbars-fixed .wy-footerbar {
  position: fixed;
}
.wy-footerbars-fixed .wy-footerbar::after {
  position: fixed;
  height: var(--wy-footerbar-height, 4rem);
}

.wy-avatar {
  border-radius: 50%;
}

.wy-avatar-initials {
  background-color: var(--wy-component-avatar-background-color, var(--wy-primary, var(--wy-primary-40, #006399)));
  color: var(--wy-component-avatar-color, var(--wy-on-primary, var(--wy-white, #ffffff)));
  width: var(--wy-component-avatar-size, 2rem);
  height: var(--wy-component-avatar-size, 2rem);
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
  font-size: calc(var(--wy-component-avatar-size, 2rem));
}
.wy-avatar-initials > span {
  font-size: max(8px, var(--wy-avatar-font-size, 0.382em));
  font-weight: var(--wy-avatar-font-weight, 600);
  line-height: 1;
}

.wy-avatar-header {
  padding: 1.5rem;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.wy-avatar-presence {
  position: relative;
  display: flex;
}

.wy-avatar-group {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  width: var(--wy-component-avatar-size, 2rem);
  height: var(--wy-component-avatar-size, 2rem);
}

.wy-avatar-group wy-avatar:first-child {
  position: absolute;
  top: 0;
  left: 0;
  display: unset;
  -webkit-mask-image: radial-gradient(at bottom right, rgba(0, 0, 0, 0) calc(35% + 0.125rem), rgb(0, 0, 0) calc(35% + 0.1875rem));
  mask-image: radial-gradient(at bottom right, rgba(0, 0, 0, 0) calc(35% + 0.125rem), rgb(0, 0, 0) calc(35% + 0.1875rem));
}

.wy-avatar-group wy-avatar:last-child {
  position: absolute;
  bottom: 0;
  right: 0;
  display: unset;
}

.wy-presence {
  background-color: var(--wy-component-background-color, transparent);
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  position: absolute;
  bottom: 0;
  right: -5%;
  box-sizing: border-box;
}
.wy-presence:not(.wy-presence-active) {
  display: none;
}
.wy-presence::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: inherit;
  background-color: var(--wy-presence-active, var(--wy-green-light, #00a38b));
  background-clip: content-box;
  padding: 0.125rem;
  box-sizing: border-box;
}

.wy-presence-away::after {
  background-color: var(--wy-presence-away, var(, ));
}

.wy-presence-in-text {
  position: absolute;
  top: 0.375rem;
  left: 0.25rem;
  bottom: auto;
  right: auto;
}

.wy-button {
  --wy-component-color: var(--wy-primary, var(--wy-primary-40, #006399));
  color: var(--wy-component-color);
  background: var(--wy-component-background-color, transparent);
  padding: var(--wy-btn-padding-y, 0.5rem) var(--wy-btn-padding-x, 1.5rem);
  font-family: var(--wy-btn-font-family, var(--wy-font-family, unset)), inherit;
  font-size: var(--wy-btn-font-size, var(--wy-font-size-base, 1rem));
  font-weight: var(--wy-btn-font-weight, 400);
  line-height: var(--wy-btn-line-height, var(--wy-line-height, 1.5));
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: var(--wy-btn-border-width, 0) solid var(--wy-btn-border-color, transparent);
  border-radius: var(--wy-btn-border-radius, 1.25rem);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  position: relative;
}
.wy-button:not(.wy-button-link, :disabled) > * {
  z-index: 3;
}
.wy-button:not(.wy-button-link, :disabled)::before {
  content: "";
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background: var(--wy-component-color);
  opacity: 0%;
}
.wy-button:not(.wy-button-link, :disabled):hover::before {
  opacity: 8%;
}
.wy-button:not(.wy-button-link, :disabled):focus::before, .wy-button:not(.wy-button-link, :disabled):active::before, .wy-button:not(.wy-button-link, :disabled).wy-active::before {
  opacity: 12%;
}
.wy-button:disabled {
  opacity: var(--wy-opacity-disabled, 38%);
  cursor: unset;
  pointer-events: none;
}

.wy-button-icon {
  --wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
  width: 2.5rem;
  height: 2.5rem;
  padding: 0.5rem;
  line-height: 1;
  border-radius: var(--wy-border-radius-pill, 50rem);
  border-width: 0;
  align-items: center;
  justify-content: center;
}
.wy-button-icon.wy-active {
  --wy-component-color: var(--wy-primary, var(--wy-primary-40, #006399));
}

.wy-button-icon-inline {
  background: var(--wy-component-background-color);
  color: currentColor;
  border-radius: var(--wy-border-radius-pill, 50rem);
  display: flex;
  width: auto;
  background-clip: content-box;
}

.wy-button-inline {
  border-radius: var(--wy-border-radius-pill, 50rem);
  padding: 0.5rem 0.75rem;
}

.wy-button-primary {
  --wy-component-background-color: var(--wy-primary, var(--wy-primary-40, #006399));
  --wy-component-color: var(--wy-on-primary, var(--wy-white, #ffffff));
}

.wy-button-variant {
  --wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
  --wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
}

.wy-button-primary-text {
  --wy-component-color: var(--wy-primary, var(--wy-primary-40, #006399));
}

.wy-button-link {
  padding: 0;
  color: var(--wy-link-color, var(--wy-primary, var(--wy-primary-40, #006399)));
  text-decoration: var(--wy-link-decoration, none);
}
.wy-button-link:hover, .wy-button-link:focus {
  text-decoration: var(--wy-link-hover-decoration, unset);
}

.wy-buttons {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.wy-code, .wy-content {
  /*pre[class*="language-"]::-moz-selection,
  pre[class*="language-"] ::-moz-selection,
  code[class*="language-"]::-moz-selection,
  code[class*="language-"] ::-moz-selection {
    text-shadow: none;
    background: #ffffff;
  }

  pre[class*="language-"]::selection,
  pre[class*="language-"] ::selection,
  code[class*="language-"]::selection,
  code[class*="language-"] ::selection {
    text-shadow: none;
    background: #ffffff;
  }*/
  /* Code blocks */
}
.wy-code pre, .wy-content pre {
  text-wrap: pretty;
}
.wy-code code[class*=language-],
.wy-code pre[class*=language-], .wy-content code[class*=language-],
.wy-content pre[class*=language-] {
  color: var(--wy-code-text, var(--wy-code-text-light, #3b3b3b));
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  text-align: left;
  white-space: pre-wrap;
  word-spacing: normal;
  word-break: normal;
  word-wrap: break-word;
  line-height: 1.5;
  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;
  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}
@media print {
  .wy-code code[class*=language-],
  .wy-code pre[class*=language-], .wy-content code[class*=language-],
  .wy-content pre[class*=language-] {
    text-shadow: none;
  }
}
.wy-code pre[class*=language-], .wy-content pre[class*=language-] {
  padding: 1em;
  margin: 0.5em 0;
  overflow: auto;
}
.wy-code :not(pre) > code[class*=language-],
.wy-code pre[class*=language-], .wy-content :not(pre) > code[class*=language-],
.wy-content pre[class*=language-] {
  color: var(--wy-code-text, var(--wy-code-text-light, #3b3b3b));
  background: var(--wy-background, var(--wy-neutral-99, #fcfcff));
}
.wy-code :not(pre) > code[class*=language-], .wy-content :not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}
.wy-code .token.variable, .wy-content .token.variable {
  color: var(--wy-code-variable, var(--wy-code-variable-light, #001080));
}
.wy-code .token.operator, .wy-content .token.operator {
  color: var(--wy-code-operator, var(--wy-code-operator-light, #000000));
}
.wy-code .token.prolog, .wy-content .token.prolog {
  color: var(--wy-code-prolog, var(--wy-code-prolog-light, #000080));
}
.wy-code .token.comment, .wy-content .token.comment {
  color: var(--wy-code-comment, var(--wy-code-comment-light, #008000));
}
.wy-code .token.builtin, .wy-content .token.builtin {
  color: var(--wy-code-builtin, var(--wy-code-builtin-light, #0070C1));
}
.wy-code .token.number, .wy-content .token.number {
  color: var(--wy-code-number, var(--wy-code-number-light, #098658));
}
.wy-code .token.inserted, .wy-content .token.inserted {
  color: var(--wy-code-inserted, var(--wy-code-inserted-light, #098658));
}
.wy-code .token.constant, .wy-content .token.constant {
  color: var(--wy-code-constant, var(--wy-code-constant-light, #811F3F));
}
.wy-code .token.hexcode, .wy-content .token.hexcode {
  color: var(--wy-code-hexcode, var(--wy-code-hexcode-light, #811F3F));
}
.wy-code .token.regex, .wy-content .token.regex {
  color: var(--wy-code-regex, var(--wy-code-regex-light, #811F3F));
}
.wy-code .token.char, .wy-content .token.char {
  color: var(--wy-code-char, var(--wy-code-char-light, #811F3F));
}
.wy-code .token.tag, .wy-content .token.tag {
  color: var(--wy-code-tag, var(--wy-code-tag-light, #800000));
}
.wy-code .token.attr-name, .wy-content .token.attr-name {
  color: var(--wy-code-attr-name, var(--wy-code-attr-name-light, #E50000));
}
.wy-code .token.selector, .wy-content .token.selector {
  color: var(--wy-code-selector, var(--wy-code-selector-light, #E50000));
}
.wy-code .token.property, .wy-content .token.property {
  color: var(--wy-code-property, var(--wy-code-property-light, #E50000));
}
.wy-code .token.deleted, .wy-content .token.deleted {
  color: var(--wy-code-deleted, var(--wy-code-deleted-light, #A31515));
}
.wy-code .token.string, .wy-content .token.string {
  color: var(--wy-code-string, var(--wy-code-string-light, #A31515));
}
.wy-code .token.changed, .wy-content .token.changed {
  color: var(--wy-code-changed, var(--wy-code-changed-light, #0451A5));
}
.wy-code .token.punctuation, .wy-content .token.punctuation {
  color: var(--wy-code-punctuation, var(--wy-code-punctuation-light, #000000));
}
.wy-code .token.function, .wy-content .token.function {
  color: var(--wy-code-function, var(--wy-code-function-light, #0000FF));
}
.wy-code .token.keyword, .wy-content .token.keyword {
  color: var(--wy-code-keyword, var(--wy-code-keyword-light, #AF00DB));
}
.wy-code .token.class-name, .wy-content .token.class-name {
  color: var(--wy-code-class-name, var(--wy-code-class-name-light, #267F99));
}
.wy-code .token.important,
.wy-code .token.bold, .wy-content .token.important,
.wy-content .token.bold {
  font-weight: bold;
}
.wy-code .token.italic, .wy-content .token.italic {
  font-style: italic;
}

.wy-content {
  overflow-wrap: break-word;
  min-width: 0;
}
.wy-content :not(pre) > code {
  overflow-wrap: inherit;
}
.wy-content pre, .wy-content pre > code[class*=language-] {
  white-space: pre-wrap;
}
.wy-content :last-child {
  margin-bottom: 0;
}
.wy-content:empty {
  display: none;
}

.wy-hashtag {
  color: var(--wy-primary, var(--wy-primary-40, #006399));
}

.wy-mention {
  font-weight: 500;
}

.wy-dropdown,
.wy-dropup {
  position: relative;
}

.wy-dropup .wy-dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.wy-dropdown-toggle {
  white-space: nowrap;
}

.wy-dropdown-menu {
  --wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  position: absolute;
  z-index: 1000;
  min-width: 10rem;
  padding: 0 0;
  margin: 0;
  font-size: var(--wy-font-size-base, 1rem);
  text-align: left;
  list-style: none;
  background-clip: padding-box;
  border-radius: var(--wy-border-radius, 0.5rem);
  box-shadow: var(--wy-shadow-level1, 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.14), 0 0.1875rem 0.0625rem -0.125rem rgba(0, 0, 0, 0.2), 0 0.0625rem 0.3125rem 0 rgba(0, 0, 0, 0.12));
  overflow: hidden;
  display: block;
}
.wy-dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: 0.25rem;
}
.wy-dropup .wy-dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0;
}
[data-bs-toggle=dropdown] ~ .wy-dropdown-menu:not(.show) {
  display: none;
}
[data-bs-toggle=dropdown] ~ .wy-dropdown-menu[hidden].show {
  display: block !important;
}

.wy-dropdown-menu-end {
  right: 0;
}

.wy-dropdown-item {
  background-color: transparent;
  color: var(--wy-component-color, var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e)));
  display: block;
  width: 100%;
  padding: 0.75rem 1rem;
  clear: both;
  font-family: var(--wy-font-family, unset), inherit;
  font-size: inherit;
  font-weight: 400;
  line-height: 1;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  border: 0;
  gap: 0.25rem;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.wy-dropdown-item:hover, .wy-dropdown-item:focus {
  --wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
  --wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
  color: var(--wy-component-color);
  background-color: var(--wy-component-background-color);
  text-decoration: none;
}
.wy-dropdown-item.wy-active, .wy-dropdown-item:active {
  --wy-component-color: var(--wy-on-primary-container, var(--wy-primary-10, #001d32));
  --wy-component-background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
  color: var(--wy-component-color);
  background-color: var(--wy-component-background-color);
  text-decoration: none;
}
.wy-dropdown-item.wy-disabled, .wy-dropdown-item:disabled {
  color: var(--wy-component-color);
  background-color: var(--wy-component-background-color);
  pointer-events: none;
  opacity: var(--wy-opacity-disabled, 38%);
}
.wy-dropdown-item > img, .wy-dropdown-item > wy-icon {
  margin-right: 0.5rem;
}
.wy-dropdown-item > img, .wy-dropdown-item > img .wy-icon, .wy-dropdown-item > wy-icon, .wy-dropdown-item > wy-icon .wy-icon {
  color: inherit;
}
.wy-dropdown-item:active > wy-icon, .wy-dropdown-item:active > wy-icon .wy-icon {
  color: inherit;
}
.wy-dropdown-item.wy-option wy-icon {
  visibility: hidden;
}
.wy-dropdown-item.wy-option.wy-selected wy-icon {
  visibility: visible;
}

.wy-dropdown-divider {
  height: 0;
  margin: 0;
  overflow: hidden;
  border: none;
  border-top: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}

.wy-emoji {
  font-size: 1.25em;
  width: 1em;
  height: 1em;
  vertical-align: -0.125em;
  line-height: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

img.wy-emoji, svg.wy-emoji {
  vertical-align: -0.25em;
}

.wy-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 0;
  position: relative;
}

.wy-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  position: relative;
  width: var(--wy-component-icon-width);
  height: var(--wy-component-icon-height);
}
.wy-icon:not([width]) {
  width: var(--wy-component-icon-width, 1.5rem);
}
.wy-icon:not([height]) {
  height: var(--wy-component-icon-height, 1.5rem);
}

.wy-icon-first {
  margin-left: -0.5rem;
}

.wy-icon-last {
  margin-right: -0.5rem;
}

.wy-icon-padded {
  margin: 16.66666667%;
}

.wy-icon-inline {
  vertical-align: -0.25em;
}

.wy-icon-overlay {
  position: absolute;
  bottom: 0;
  right: 0;
  background: var(--wy-component-background-color, var(--wy-background, var(--wy-neutral-99, #fcfcff)));
  border-radius: 50%;
  border: 1px solid var(--wy-component-background-color, var(--wy-background, var(--wy-neutral-99, #fcfcff)));
}

.wy-icon-stack {
  display: inline-flex;
  position: relative;
  line-height: 1;
}
.wy-icon-stack .wy-icon:last-child, .wy-icon-stack > svg:last-child {
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: var(--wy-component-background-color, var(--wy-background, var(--wy-neutral-99, #fcfcff)));
  border-radius: 50%;
  width: calc(var(--wy-component-icon-width) / 2);
  height: calc(var(--wy-component-icon-height) / 2);
}

.wy-icon-active-stack {
  display: inline-flex;
  position: relative;
  line-height: 1;
}
.wy-icon-active-stack .wy-icon-stack-item {
  transition: opacity var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  align-self: center;
  justify-self: center;
  margin: auto;
}
.wy-icon-active-stack .wy-icon-stack-item:last-child {
  position: absolute;
  opacity: 0;
}
.wy-icon-active-stack.wy-active .wy-icon-stack-item:first-child, .wy-active .wy-icon-active-stack .wy-icon-stack-item:first-child {
  opacity: 0;
}
.wy-icon-active-stack.wy-active .wy-icon-stack-item:last-child, .wy-active .wy-icon-active-stack .wy-icon-stack-item:last-child {
  opacity: 1;
}

.wy-icon:not([class*=wy-icon-color-]):not([class*=wy-kind-]):not([data-icon=progress]) * {
  fill: currentColor;
}

.wy-content-icon {
  color: var(--wy-component-color, var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e)));
  border-radius: var(--wy-component-border-radius, var(--wy-border-radius-lg, calc(1.5 * var(--wy-border-radius, 0.5rem))));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 1rem 2rem;
  margin: auto;
}
.wy-content-icon > .wy-icon-stack, .wy-content-icon > .wy-icon, .wy-content-icon > wy-icon, .wy-content-icon ::slotted(.wy-icon-stack), .wy-content-icon ::slotted(.wy-icon), .wy-content-icon ::slotted(wy-icon) {
  --wy-component-icon-width: 4rem;
  --wy-component-icon-height: 4rem;
}

.wy-content-name, .wy-content-meta {
  padding: 1rem 2rem;
  text-align: center;
}

.wy-icon-color-theme *, .wy-icon-color-theme * * {
  fill: var(--wy-theme, var(, ));
}

.wy-icon-color-primary *, .wy-icon-color-primary * * {
  fill: var(--wy-primary, var(--wy-primary-40, #006399));
}

.wy-icon-color-secondary *, .wy-icon-color-secondary * * {
  fill: var(--wy-secondary, var(--wy-secondary-40, #3b6a1c));
}

.wy-icon-color-tertiary *, .wy-icon-color-tertiary * * {
  fill: var(--wy-tertiary, var(--wy-tertiary-40, #3b6a1c));
}

.wy-icon-color-surface *, .wy-icon-color-surface * * {
  fill: var(--wy-surface, var(--wy-neutral-99, #fcfcff));
}

.wy-icon-color-surface-variant *, .wy-icon-color-surface-variant * * {
  fill: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
}

.wy-icon-color-error *, .wy-icon-color-error * * {
  fill: var(--wy-error, var(--wy-error-40, #ba1824));
}

.wy-icon-color-warning *, .wy-icon-color-warning * * {
  fill: var(--wy-warning, var(--wy-warning-70, #afb140));
}

.wy-icon-color-blue *, .wy-icon-color-blue * * {
  fill: var(--wy-blue, var(--wy-blue-light, #89a9fc));
}

.wy-icon-color-indigo *, .wy-icon-color-indigo * * {
  fill: var(--wy-indigo, var(--wy-indigo-light, #9185de));
}

.wy-icon-color-purple *, .wy-icon-color-purple * * {
  fill: var(--wy-purple, var(--wy-purple-light, #c675b7));
}

.wy-icon-color-pink *, .wy-icon-color-pink * * {
  fill: var(--wy-pink, var(--wy-pink-light, #d57194));
}

.wy-icon-color-red *, .wy-icon-color-red * * {
  fill: var(--wy-red, var(--wy-red-light, #db726c));
}

.wy-icon-color-orange *, .wy-icon-color-orange * * {
  fill: var(--wy-orange, var(--wy-orange-light, #e89a3a));
}

.wy-icon-color-yellow *, .wy-icon-color-yellow * * {
  fill: var(--wy-yellow, var(--wy-yellow-light, #afb140));
}

.wy-icon-color-green *, .wy-icon-color-green * * {
  fill: var(--wy-green, var(--wy-green-light, #00a38b));
}

.wy-icon-color-teal *, .wy-icon-color-teal * * {
  fill: var(--wy-teal, var(--wy-teal-light, #00a0a8));
}

.wy-icon-color-cyan *, .wy-icon-color-cyan * * {
  fill: var(--wy-cyan, var(--wy-cyan-light, #0082a1));
}

.wy-icon-color-gray *, .wy-icon-color-gray * * {
  fill: var(--wy-gray, var(--wy-gray-light, #76777a));
}

.wy-icon-color-black *, .wy-icon-color-black * * {
  fill: var(--wy-black, var(, ));
}

.wy-icon-color-white *, .wy-icon-color-white * * {
  fill: var(--wy-white, var(, ));
}

[class*=wy-kind-], [class*=wy-kind-] * {
  fill: var(--wy-gray, var(--wy-gray-light, #76777a));
}

.wy-kind-archive {
  fill: var(--wy-orange, var(--wy-orange-light, #e89a3a));
}

.wy-kind-audio * {
  fill: var(--wy-teal, var(--wy-teal-light, #00a0a8));
}

.wy-kind-code * {
  fill: var(--wy-green, var(--wy-green-light, #00a38b));
}

.wy-kind-document * {
  fill: var(--wy-blue, var(--wy-blue-light, #89a9fc));
}

.wy-kind-email * {
  fill: var(--wy-red, var(--wy-red-light, #db726c));
}

.wy-kind-presentation * {
  fill: var(--wy-orange, var(--wy-orange-light, #e89a3a));
}

.wy-kind-spreadsheet * {
  fill: var(--wy-green, var(--wy-green-light, #00a38b));
}

.wy-kind-image * {
  fill: var(--wy-pink, var(--wy-pink-light, #d57194));
}

.wy-kind-text * {
  fill: var(--wy-cyan, var(--wy-cyan-light, #0082a1));
}

.wy-kind-video * {
  fill: var(--wy-purple, var(--wy-purple-light, #c675b7));
}

.wy-ext-pdf * {
  fill: var(--wy-red, var(--wy-red-light, #db726c));
}

.wy-kind-text-icon {
  width: 1.25rem;
  height: 1.25rem;
  vertical-align: -0.3125rem;
}

[data-icon=progress].wy-icon-primary {
  color: var(--wy-primary, var(--wy-primary-40, #006399));
}
[data-icon=progress] :first-child {
  fill: none;
  stroke: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
}
[data-icon=progress] :last-child {
  fill: none;
  stroke: currentColor;
}

.wy-image-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  position: relative;
  border-radius: var(--wy-border-radius, 0.5rem);
  overflow: hidden;
  column-gap: 1px;
  row-gap: 1px;
}
.wy-image-grid .wy-image {
  padding: 0;
  width: 50%;
  position: relative;
  flex: auto;
  background-color: inherit;
  background-clip: content-box;
}
.wy-image-grid .wy-image:first-of-type:not(:nth-last-of-type(2)) {
  flex-basis: 100% !important;
}
.wy-image-grid .wy-image-area {
  display: block;
  height: 100%;
  cursor: pointer;
}
.wy-image-grid .wy-image-area img {
  position: absolute;
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.wy-image-grid .wy-more {
  position: absolute;
  line-height: 100%;
  color: var(--wy-white, var(, ));
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  background: rgba(0, 0, 0, var(--wy-opacity-disabled, 38%));
}

.wy-title {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-style: var(--wy-headings-font-style, unset);
  font-weight: var(--wy-headings-font-weight, 500);
  line-height: var(--wy-headings-line-height, var(--wy-line-height, 1.5));
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-weight: 400;
  font-size: 2.5rem;
  line-height: 3rem;
}

.wy-headline {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-style: var(--wy-headings-font-style, unset);
  font-weight: var(--wy-headings-font-weight, 500);
  line-height: var(--wy-headings-line-height, var(--wy-line-height, 1.5));
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 2rem;
}

.wy-label {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-style: var(--wy-headings-font-style, unset);
  font-weight: var(--wy-headings-font-weight, 500);
  line-height: var(--wy-headings-line-height, var(--wy-line-height, 1.5));
  margin-top: 0rem;
  margin-bottom: 0rem;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
}

.wy-input {
  --wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  border: var(--wy-input-border-width, 1px) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  display: block;
  width: 100%;
  padding: var(--wy-input-padding-y, 0.4375rem) var(--wy-input-padding-x, 0.75rem);
  font-family: var(--wy-input-font-family, var(--wy-font-family, inherit)), inherit;
  font-size: var(--wy-input-font-size, var(--wy-font-size-base, 1rem));
  font-weight: var(--wy-input-font-weight, var(--wy-font-weight, unset));
  line-height: var(--wy-input-line-height, var(--wy-line-height, 1.5rem));
  background-clip: padding-box;
  appearance: none;
  border-radius: var(--wy-input-border-radius, var(--wy-border-radius, 0.5rem));
}
.wy-input:focus {
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  color: var(--wy-component-color);
  border-color: var(--wy-primary, var(--wy-primary-40, #006399));
  outline: 0;
}
.wy-input::placeholder {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  opacity: 1;
}
.wy-input:disabled {
  opacity: 38%;
}
.wy-input::file-selector-button, .wy-input::-webkit-file-upload-button {
  color: var(--wy-component-color);
  background-color: var(--wy-component-background-color);
  padding: var(--wy-input-padding-y, 0.4375rem) var(--wy-input-padding-x, 0.75rem);
  margin: calc(-1 * var(--wy-input-padding-y, 0.4375rem)) calc(-1 * var(--wy-input-padding-x, 0.75rem));
  margin-inline-end: var(--wy-input-padding-x, 0.75rem);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--wy-input-border-width, 1px);
  border-radius: 0;
}
.wy-input:hover:not(:disabled):not([readonly])::file-selector-button, .wy-input:hover:not(:disabled):not([readonly]) ::-webkit-file-upload-button {
  background-color: var(--wy-component-background-color);
}
.wy-input[type=file] {
  overflow: hidden;
}
.wy-input[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.wy-input::-webkit-date-and-time-value {
  height: calc(var(--wy-input-line-height, var(--wy-line-height, 1.5rem)) * 1em);
}
.wy-input[type=search]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

.wy-input-filled {
  --wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  border-radius: 1.25rem;
  border-color: var(--wy-component-background-color);
}
.wy-input-filled:focus {
  border-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}

.wy-input-label {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-style: var(--wy-headings-font-style, unset);
  font-weight: var(--wy-headings-font-weight, 500);
  line-height: var(--wy-headings-line-height, var(--wy-line-height, 1.5));
  margin-top: 0rem;
  margin-bottom: 0rem;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  display: block;
  margin-bottom: 0.5rem;
}

.wy-description {
  margin-top: 0.25rem;
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
}

.wy-is-invalid, .wy-is-invalid:focus {
  border-color: var(--wy-error, var(--wy-error-40, #ba1824));
}

.wy-invalid-feedback {
  margin-top: 0.25rem;
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
  color: var(--wy-error, var(--wy-error-40, #ba1824));
}

.wy-input-group {
  position: relative;
}
.wy-input-group > wy-icon {
  position: absolute;
  top: 0rem;
  left: 0rem;
  z-index: 4;
}
.wy-input-group > wy-icon + .wy-input {
  padding-left: 2.5rem;
}

.wy-input-group-button-icon {
  position: absolute;
  top: 0rem;
  right: 0rem;
  z-index: 4;
  border-radius: var(--wy-input-border-radius, var(--wy-border-radius, 0.5rem));
}

.wy-input-group-input-filled ~ .wy-button-icon {
  border-radius: 1.25rem;
}

.wy-input-group-input {
  padding-right: 2.5rem;
}
.wy-input-group-input:placeholder-shown ~ .wy-input-group-button-icon[type=reset] {
  display: none;
}
.wy-input-group-input:not(:placeholder-shown) ~ .wy-input-group-button-icon[type=reset] + .wy-input-group-button-icon {
  display: none;
}

.wy-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.75rem;
  text-decoration: none;
  min-height: 3rem;
}
.wy-item > .wy-avatar, .wy-item > wy-icon, .wy-item > wy-spinner, .wy-item > .wy-icon-stack {
  margin-left: -0.25rem;
}

.wy-item-body {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wy-item-body > * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wy-item-body + .wy-dropdown, .wy-item-body + .wy-button-icon, .wy-item-body + .wy-item-actions {
  margin-right: -0.5rem;
}
.wy-item-body + .wy-emoji {
  margin-right: 0.125rem;
}

.wy-item-title {
  color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  font-weight: var(--wy-headings-font-weight, 500);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wy-item-text {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
}
.wy-item-text .wy-icon {
  width: 1.25rem;
  height: 1.25rem;
  vertical-align: -0.3125rem;
}

.wy-item-actions {
  --wy-component-background-color: transparent;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

.wy-item-actions-top {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  margin: 0 !important;
}

.wy-item-actions-bottom {
  position: absolute;
  bottom: 0.25rem;
  right: 0.25rem;
  margin: 0 !important;
}

.wy-item-body:has(+ .wy-item-actions-bottom) .wy-item-row:last-child {
  margin-right: 4.5rem;
}

.wy-item-body:has(+ .wy-item-actions-top) .wy-item-row:first-child {
  margin-right: 2rem;
}

.wy-action-label {
  margin-right: 0.5rem;
  font-style: italic;
}

.wy-item-row {
  display: flex;
  align-items: baseline;
}
.wy-item-row:first-child {
  margin-bottom: 0.125rem;
}
.wy-item-row .wy-item-title {
  margin-right: auto;
}
.wy-item-row .wy-item-text {
  margin-right: auto;
}
.wy-item-row .wy-meta {
  margin: 0 0.25rem;
  white-space: nowrap;
}

.wy-item-hover {
  user-select: none;
  cursor: pointer;
}
.wy-item-hover:hover, .wy-item-hover:focus {
  --wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  text-decoration: none;
}
.wy-item-hover:active {
  --wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
  --wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}
.wy-item-hover.wy-disabled, .wy-item-hover:disabled {
  opacity: var(--wy-opacity-disabled, 38%);
  pointer-events: none;
}
.wy-item-hover.wy-active {
  --wy-component-background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
  --wy-component-color: var(--wy-on-primary-container, var(--wy-primary-10, #001d32));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  border-color: var(--wy-component-background-color);
}

.wy-item-trashed {
  text-decoration: line-through;
  opacity: var(--wy-opacity-disabled, 38%);
}
.wy-item-trashed.wy-item-hover:hover {
  opacity: 1;
}

.wy-item-lg {
  padding: 0.75rem;
  min-height: 4.5rem;
  gap: 0.75rem;
}
.wy-item-lg > .wy-avatar, .wy-item-lg > wy-icon, .wy-item-lg > .wy-icon-stack {
  margin-left: 0;
}

.wy-list {
  border-radius: var(--wy-border-radius-sm, calc(0.75 * var(--wy-border-radius, 0.5rem)));
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.wy-list .wy-item:not(.wy-item-hover) {
  --wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}
.wy-list .wy-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.wy-list .wy-item:last-child {
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}

.wy-list-bordered {
  border: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  gap: 0;
}
.wy-list-bordered .wy-item {
  border-top: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  border-left: none;
  border-right: none;
}
.wy-list-bordered .wy-item:first-child {
  border-top: none;
}
.wy-list-bordered .wy-item:last-child {
  border-bottom: none;
}
.wy-list-bordered .wy-item + .wy-list-bordered .wy-item {
  border-top-width: 0;
}

.wy-messages {
  padding: 1rem 1rem 1rem 0.75rem;
  flex: 1 1 100%;
}

.wy-message-placeholder {
  opacity: 0.5;
}

.wy-date-separator {
  font-size: var(--wy-font-size-xs, calc(0.75 * var(--wy-font-size-base, 1rem)));
  pointer-events: none;
  margin: 0.5rem;
  text-align: center;
  position: sticky;
  top: 1.5rem;
  z-index: 10;
}
.wy-date-separator time {
  background: var(--wy-surface-3, var(--wy-surface-3-light, #e3e7ee));
  color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  padding: 0.25rem 0.5rem;
  border-radius: var(--wy-border-radius-sm, calc(0.75 * var(--wy-border-radius, 0.5rem)));
  display: inline-block;
}

.wy-appbars + .wy-pane-body .wy-date-separator {
  top: calc(var(--wy-appbar-height, 3rem) + 1.5rem);
}

.wy-message {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 1rem;
}
.wy-message .wy-image-grid,
.wy-message .wy-attachments {
  border-radius: var(--wy-border-radius, 0.5rem);
}

.wy-message-meta {
  font-size: var(--wy-font-size-xs, calc(0.75 * var(--wy-font-size-base, 1rem)));
  margin: 0 0 0.25rem 0.25rem;
  color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
}

.wy-message-bubble {
  --wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
  --wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  border-radius: calc(var(--wy-border-radius, 0.5rem) + .5rem);
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  gap: 0.75rem;
  max-width: min(32rem, 100% - 2rem);
}
.wy-message-bubble > div {
  flex: 1 1 100%;
}
.wy-message-bubble .wy-likes, .wy-message-bubble .wy-reactions-line {
  position: relative;
  height: 0;
  min-height: 0;
  max-height: 0;
  margin: 0 -0.75rem -0.75rem;
  flex: 0 0 0;
}
.wy-message-bubble .wy-like-count {
  background: var(--wy-component-background-color);
  border-radius: var(--wy-border-radius-pill, 50rem);
  color: currentColor;
}
.wy-message-bubble .wy-reactions-line, .wy-message-bubble wy-reactions {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
}

.wy-message-author {
  margin: 1.375rem 0.5rem 0 0;
}

.wy-message-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  flex-wrap: wrap;
  min-width: 0;
  position: relative;
}

.wy-message-content-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 100%;
}

.wy-message-me {
  margin-right: 0;
  margin-left: 2.5rem;
  align-items: flex-end;
}
.wy-message-me .wy-message-meta {
  margin: 0 0.25rem 0.25rem 0;
}
.wy-message-me .wy-message-content {
  align-items: flex-end;
}
.wy-message-me .wy-message-content-row {
  flex-direction: row-reverse;
}
.wy-message-me .wy-message-bubble {
  --wy-component-background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
  --wy-component-color: var(--wy-on-primary-container, var(--wy-primary-10, #001d32));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}
.wy-message-me .wy-likes {
  flex-direction: row-reverse;
}
.wy-message-me .wy-reactions-line, .wy-message-me wy-reactions {
  display: flex;
  flex-direction: row;
}
.wy-message-me .wy-reactions-line .wy-dropdown-menu, .wy-message-me wy-reactions .wy-dropdown-menu {
  right: 0;
}

.wy-message-emoji .wy-message-bubble {
  background: none;
  padding: 0 0 0.75rem;
}
.wy-message-emoji .wy-content .wy-emoji {
  width: 3rem;
  height: 3rem;
  margin: 0;
}
.wy-message-emoji.wy-message-me .wy-content {
  text-align: end;
}

.wy-readby-status {
  display: flex;
  gap: 0.25rem;
  height: 18px;
  justify-content: flex-end;
  margin-top: -0.125rem;
}

.wy-status-pending {
  --wy-component-background-color: var(--wy-inverse-primary, var(--wy-primary-80, #95ccff));
  color: var(--wy-component-background-color);
}

.wy-status-sent {
  --wy-component-background-color: var(--wy-inverse-primary, var(--wy-primary-80, #95ccff));
  color: var(--wy-component-background-color);
}

.wy-status-delivered {
  --wy-component-background-color: var(--wy-inverse-primary, var(--wy-primary-80, #95ccff));
  color: var(--wy-component-background-color);
}

.wy-message-readmore {
  justify-self: center;
  text-align: center;
}

.wy-meta {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
}

.wy-meta-sm {
  font-size: var(--wy-font-size-xs, calc(0.75 * var(--wy-font-size-base, 1rem)));
}

.wy-viewport {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2147483647; /* max possible z-index */
  pointer-events: none;
}

.wy-overlays {
  pointer-events: none;
  width: 100%;
  height: 100%;
  max-width: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-style: preserve-3d;
  overflow-y: initial;
  overflow-x: initial;
  perspective: 100rem;
  perspective-origin: center center;
}
.wy-overlays .wy-panel:not(.wy-transition) {
  transform: translateZ(-4rem) !important;
}
.wy-overlays .wy-panel .wy-controls {
  position: absolute;
  border-bottom: none;
  flex-direction: row;
  transition: opacity 0.1s 0.2s step-end;
}
.wy-overlays .wy-panel .wy-controls wy-icon {
  color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
}
.wy-overlays .wy-panel.wy-loaded .wy-controls {
  pointer-events: none;
  opacity: 0;
}
.wy-overlays .wy-panel .wy-panel-frame {
  background-color: transparent;
}
@media (min-width: 768px) {
  .wy-overlays .wy-panel.wy-modal {
    left: auto;
    right: auto;
    top: 2rem;
    bottom: 3.2rem;
    margin-left: 4rem;
    margin-top: auto;
    margin-right: 4rem;
    margin-bottom: auto;
    border-radius: var(--wy-border-radius, 0.5rem);
    box-shadow: var(--wy-shadow-level4, 0 1rem 2.25rem 0.125rem rgba(0, 0, 0, 0.14), 0 0.375rem 1.875rem 0.3125rem rgba(0, 0, 0, 0.12), 0 0.5rem 0.625rem -0.3125rem rgba(0, 0, 0, 0.2));
    width: 32rem;
    max-height: 32rem;
  }
  .wy-overlays .wy-panel.wy-modal:not(.wy-scroll-y) {
    overflow: hidden;
  }
}
@media (min-width: 768px) {
  .wy-overlays .wy-panel.wy-modal-full {
    left: 1rem;
    top: 1rem;
    right: 1rem;
    bottom: 1rem;
    margin: 0;
    border-radius: var(--wy-border-radius, 0.5rem);
    box-shadow: var(--wy-shadow-level4, 0 1rem 2.25rem 0.125rem rgba(0, 0, 0, 0.14), 0 0.375rem 1.875rem 0.3125rem rgba(0, 0, 0, 0.12), 0 0.5rem 0.625rem -0.3125rem rgba(0, 0, 0, 0.2));
    width: auto;
    max-height: none;
  }
  .wy-overlays .wy-panel.wy-modal-full:not(.wy-scroll-y) {
    overflow: hidden;
  }
}
.wy-overlays .wy-panel.wy-loading .wy-controls {
  transition: opacity var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  opacity: 1;
}

tr.wy-pager {
  pointer-events: none;
}

:not(tr).wy-pager:not(:empty) {
  display: block;
  text-align: center;
  margin: 1rem auto;
}

tr.wy-pager td {
  text-align: center;
  border: 0;
}
tr.wy-pager td .wy-spinner {
  display: inline;
  margin: 1rem auto;
}

.wy-grid .wy-pager {
  display: flex;
}

.wy-pane {
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 0;
  height: 100%;
  flex: 1 1 auto;
}

.wy-pane-body {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.wy-pane-group {
  padding: 0.75rem;
}

.wy-pane-background {
  --wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}

.wy-panels {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overscroll-behavior: contain;
  overflow-y: auto;
  overflow-x: hidden;
}

.wy-panel {
  --wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  overflow: hidden;
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  display: flex;
  flex-direction: column;
}
.wy-panel .wy-controls {
  top: 0.25rem;
  left: 0.25rem;
  min-width: 2.5rem;
  width: auto;
  display: flex;
  z-index: 10000;
  order: -1;
  flex-direction: row-reverse;
  border-bottom: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}
.wy-panel .wy-controls:empty {
  display: none;
}
.wy-panel .wy-controls wy-icon {
  color: var(--wy-component-color);
}
.wy-panel .wy-panel-frame {
  transition: opacity var(--wy-transition-fast, var(--wy-transition-duration-fast, 0.1s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  transition-delay: 0.2s;
  opacity: 1;
}
.wy-panel .wy-panel-frame:not([src]) {
  display: none;
}
.wy-panel:not(.wy-loaded) .wy-panel-frame {
  opacity: 0;
  transition: opacity 0.2s step-start;
  transition-delay: 0.1s;
}
.wy-panel.wy-open {
  pointer-events: all;
  z-index: 5;
}
.wy-panel.wy-open[data-title]::before {
  content: attr(data-title);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: var(--wy-appbar-height, 3rem);
  padding: 0.25rem;
  opacity: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.1s step-end;
  transition-delay: 0.2s;
  font-family: var(--wy-font-family, unset), inherit;
  line-height: var(--wy-line-height, 1.5);
  font-weight: var(--wy-font-weight, unset);
  background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  box-shadow: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0px -1px 0px 0px inset;
  backface-visibility: hidden;
}
@supports (backdrop-filter: blur(0.5rem)) {
  .wy-panel.wy-open[data-title]::before {
    backdrop-filter: blur(0.5rem);
  }
}
.wy-panel.wy-open::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  opacity: 0;
  transition: opacity var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  transition-duration: 0s;
}
.wy-panel.wy-open.wy-loading[data-title]::before {
  opacity: 1;
}
.wy-panel.wy-open.wy-loading::after {
  transition: opacity var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  transition-duration: 0.5s;
  opacity: 1;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' width='24' height='24' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cstyle type='text/css'%3Eg%7Banimation:rotate 2s linear infinite;transform-origin:center center%7Dcircle%7Bstroke-dasharray:1,100;stroke-dashoffset:0;animation:dash 1.5s ease-in-out infinite,color 6s ease-in-out infinite%7D@keyframes rotate%7B100%25%7Btransform:rotate(360deg)%7D%7D@keyframes dash%7B0%25%7Bstroke-dasharray:1,100;stroke-dashoffset:0%7D50%25%7Bstroke-dasharray:44.5,100;stroke-dashoffset:-17.5px%7D100%25%7Bstroke-dasharray:44.5,100;stroke-dashoffset:-62px%7D%7D@keyframes color%7B0%25,100%25%7Bstroke:%23216eb4%7D40%25%7Bstroke:%2328b7cf%7D66%25%7Bstroke:%23216eb4%7D80%25,90%25%7Bstroke:%2328b7cf%7D%7D%3C/style%3E%3Cg%3E%3Ccircle fill='none' cx='12' cy='12' r='11' stroke-linecap='butt' stroke-width='2' /%3E%3C/g%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 2rem;
  background-color: transparent;
}

.wy-panel {
  opacity: 0;
  visibility: hidden;
  transition: opacity var(--wy-transition-fast, var(--wy-transition-duration-fast, 0.1s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))) 0.01s, transform var(--wy-transition-fast, var(--wy-transition-duration-fast, 0.1s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))) 0.01s, visibility 0.01s step-end var(--wy-transition-duration-fast, 0.1s);
}
.wy-panel.wy-open {
  transition: opacity var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))), transform var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))), visibility var(--wy-transition-duration, 0.2s) step-start;
  visibility: visible;
}
.wy-panel.wy-open.wy-transition {
  opacity: 1;
  transform: none;
}

.wy-panel-frame {
  flex: 1 1 100%;
  border: 0;
}

.wy-picker-list {
  background: var(--wy-component-background-color);
  color: var(--wy-component-color);
  border: none;
}
.wy-picker-list > .wy-picker-list-item:first-child, .wy-picker-list > :first-child .wy-picker-list-item {
  border-top: none;
}
.wy-picker-list > .wy-picker-list-item:last-child, .wy-picker-list > :last-child .wy-picker-list-item {
  border-bottom: none;
}

.wy-picker-list-item {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
}
.wy-picker-list-item > wy-icon {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  flex: 0 0 auto;
}
.wy-picker-list-item > button {
  margin-block-start: auto;
  flex: 0 0 auto;
}

.wy-picker-list-item-title {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wy-main {
  display: flex;
  height: calc(100% - var(--wy-appbar-height, 3rem));
  min-height: 0;
}
@media (max-width: 767.98px) {
  .wy-main {
    flex-direction: column;
  }
}

.wy-preview {
  --wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  position: relative;
  flex: 1 1 100%;
  min-width: 16rem;
  min-height: 16rem;
  max-height: 100%;
  max-width: 100%;
}

.wy-preview-swiper {
  display: flex;
  flex-direction: row;
  flex: 1 1 100%;
  align-items: center;
  justify-content: start;
  min-width: 16rem;
  min-height: 16rem;
  max-height: 100%;
  max-width: 100%;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  scroll-behavior: auto;
  overscroll-behavior-x: none;
  scrollbar-width: none;
}
.wy-preview-swiper::-webkit-scrollbar {
  display: none;
}

.wy-preview-swiper-disabled {
  overflow-x: hidden;
}

.wy-preview-area {
  position: relative;
  min-width: 100%;
  min-height: 100%;
  width: 100%;
  height: 100%;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  scroll-snap-stop: always;
  scroll-snap-align: center;
}

.wy-nav-prev, .wy-nav-next {
  --wy-component-background-color: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
  --wy-component-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
  background-color: var(--wy-component-background-color);
  position: absolute;
  top: 50%;
  z-index: 1000;
  border-radius: 50%;
}

.wy-nav-prev {
  left: 0.5rem;
}

.wy-nav-next {
  right: 0.5rem;
}

.wy-document {
  --wy-component-background-color: var(--wy-background, );
  --wy-component-color: var(--wy-on-background, );
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  align-self: flex-start;
  padding: 2rem 3.5rem;
  width: 100%;
  min-height: 100%;
  flex: 1 0 auto;
}
@media (min-width: 768px) {
  .wy-document {
    padding: 3rem 4rem;
    margin: 2rem auto;
    border-radius: 0.125rem;
    box-shadow: var(--wy-shadow-level2, 0 0.25rem 0.3125rem 0 rgba(0, 0, 0, 0.14), 0 0.0625rem 0.625rem 0 rgba(0, 0, 0, 0.12), 0 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.2));
    width: 120ch;
    min-height: 170ch;
    max-width: calc(100% - 3.5rem);
  }
}

.wy-content-code {
  /*--wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));

  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  */
  align-self: flex-start;
  width: 100%;
  padding: 2rem 3.5rem;
}

.wy-content-iframe {
  border: 0;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  flex: 1 1 100%;
}
.wy-content-iframe.wy-loaded {
  --wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}
.wy-content-iframe.wy-loaded ~ .wy-content-iframe-fallback, .wy-content-iframe.wy-loaded ~ .wy-spinner, .wy-content-iframe.wy-loaded ~ wy-spinner {
  display: none;
}
.wy-content-iframe.wy-loading:not(.wy-loaded) {
  position: absolute;
  visibility: hidden;
  z-index: -1;
  pointer-events: none;
}
.wy-content-iframe.wy-loading:not(.wy-loaded):not(.wy-fallback) ~ .wy-content-iframe-fallback {
  display: none;
}
.wy-content-iframe.wy-loading:not(.wy-loaded).wy-fallback ~ .wy-spinner, .wy-content-iframe.wy-loading:not(.wy-loaded).wy-fallback ~ wy-spinner {
  display: none;
}
.wy-content-iframe ~ .wy-spinner, .wy-content-iframe ~ wy-spinner {
  margin: auto;
}

.wy-content-html pre, .wy-content-html code {
  word-break: break-word;
  white-space: pre-wrap;
}

.wy-content-image {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: auto;
  max-height: 100%;
  max-width: 100%;
  /*&.wy-intrinsic-image {
    object-fit: scale-down;
  }*/
  /*&:not(.wy-intrinsic-image) {
    transition: transform var.default(--wy-transition), transform-origin var.default(--wy-transition-duration) step-end;
    //cursor: zoom-in;
  }*/
  transition: transform var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))), transform-origin var(--wy-transition-duration, 0.2s) step-end;
}
.wy-content-image.wy-zoom {
  cursor: zoom-out;
  transition: transform var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))), transform-origin var(--wy-transition-duration, 0.2s) step-start;
}
.wy-content-image img {
  min-width: 0;
  min-height: 0;
  width: 100%;
  height: 100%;
}
.wy-content-image img:not(.wy-loading-transition):not([data-controller~=image]) ~ .wy-spinner, .wy-content-image img:not(.wy-loading-transition):not([data-controller~=image]) ~ wy-spinner {
  display: none;
}
.wy-content-image img.wy-loading, .wy-content-image img[data-controller~=image] {
  transition: opacity 0.15s ease-out;
  opacity: 0;
}
.wy-content-image img.wy-loading.wy-loaded, .wy-content-image img[data-controller~=image].wy-loaded {
  opacity: 1;
  transition: opacity 0.15s ease-out;
}
.wy-content-image img.wy-loading.wy-loaded ~ img, .wy-content-image img[data-controller~=image].wy-loaded ~ img {
  transition-delay: 0.15s;
  opacity: 0;
}
.wy-content-image img.wy-loading.wy-loaded ~ .wy-spinner, .wy-content-image img.wy-loading.wy-loaded ~ wy-spinner, .wy-content-image img[data-controller~=image].wy-loaded ~ .wy-spinner, .wy-content-image img[data-controller~=image].wy-loaded ~ wy-spinner {
  display: none;
}
.wy-content-image img.wy-responsive-image-thumb {
  position: absolute;
  z-index: -1;
}
.wy-content-image img ~ .wy-spinner, .wy-content-image img ~ wy-spinner {
  position: absolute;
}

.wy-content-video:not(.wy-error) {
  min-height: 0;
  max-width: 100%;
  max-height: 100%;
  flex: 1 1 auto;
}

.wy-content-video, .wy-content-audio {
  margin: auto;
}
.wy-content-video.wy-loading:not(.wy-loaded), .wy-content-video[data-controller~=media]:not(.wy-loaded), .wy-content-audio.wy-loading:not(.wy-loaded), .wy-content-audio[data-controller~=media]:not(.wy-loaded) {
  visibility: hidden;
}
.wy-content-video.wy-loading.wy-loaded ~ .wy-spinner, .wy-content-video.wy-loading.wy-loaded ~ wy-spinner, .wy-content-video[data-controller~=media].wy-loaded ~ .wy-spinner, .wy-content-video[data-controller~=media].wy-loaded ~ wy-spinner, .wy-content-audio.wy-loading.wy-loaded ~ .wy-spinner, .wy-content-audio.wy-loading.wy-loaded ~ wy-spinner, .wy-content-audio[data-controller~=media].wy-loaded ~ .wy-spinner, .wy-content-audio[data-controller~=media].wy-loaded ~ wy-spinner {
  display: none;
}
.wy-content-video:focus, .wy-content-audio:focus {
  outline: none;
}

:host(wy-pdf-viewer) {
  --annotation-unfocused-field-background: url("data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>");
  --input-focus-border-color: Highlight;
  --input-focus-outline: 1px solid Canvas;
  --input-unfocused-border-color: transparent;
  --input-disabled-border-color: transparent;
  --input-hover-border-color: black;
  --xfa-unfocused-field-background: url("data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>");
  --xfa-focus-outline: auto;
  --focus-outline: solid 2px blue;
  --hover-outline: dashed 2px blue;
  --freetext-line-height: 1.35;
  --freetext-padding: 2px;
  --editorFreeText-editing-cursor: text;
  --editorInk-editing-cursor: pointer;
  --viewer-container-height: 0;
  --pdfViewer-padding-bottom: 0;
  --page-margin: 2rem auto;
  --page-border: none;
  --page-border-image: none;
  --spreadHorizontalWrapped-margin-LR: -3.5px;
  --scale-factor: 1;
}
@media (forced-colors: active) {
  :host(wy-pdf-viewer) {
    --input-focus-border-color: CanvasText;
    --input-unfocused-border-color: ActiveText;
    --input-disabled-border-color: GrayText;
    --input-hover-border-color: Highlight;
  }
}
@media (forced-colors: active) {
  :host(wy-pdf-viewer) {
    --xfa-focus-outline: 2px solid CanvasText;
  }
}
@media (forced-colors: active) {
  :host(wy-pdf-viewer) {
    --focus-outline: solid 3px ButtonText;
    --hover-outline: dashed 3px ButtonText;
  }
}
@media screen and (forced-colors: active) {
  :host(wy-pdf-viewer) {
    --page-border: 1px solid CanvasText;
    --page-border-image: none;
    --spreadHorizontalWrapped-margin-LR: 3.5px;
  }
}

.wy-content-pdf {
  /* Copyright 2014 Mozilla Foundation
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  /* Only necessary in Google Chrome, see issue 14205, and most unfortunately
   * the problem doesn't show up in "text" reference tests. */
  /* Avoids https://github.com/mozilla/pdf.js/issues/13840 in Chrome */
}
.wy-content-pdf .wy-input[data-pdf-target=pageNumber] {
  width: 3rem;
}
.wy-content-pdf .wy-input[data-pdf-target=zoomLevel] {
  width: 5rem;
}
.wy-content-pdf .wy-pdf-container {
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  touch-action: pan-y, pan-x;
  will-change: scroll-position, opacity;
  backface-visibility: hidden;
  max-height: 100%;
  overflow-x: auto;
  touch-action: pan-y, pan-x;
  will-change: scroll-position, opacity;
  backface-visibility: hidden;
  max-width: 100%;
}
.wy-content-pdf .wy-pdf-container:not(body) {
  -webkit-overflow-scrolling: touch;
}
.wy-scrollbars .wy-content-pdf .wy-pdf-container {
  scrollbar-width: thin;
  scrollbar-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e)) transparent;
}
.wy-scrollbars .wy-content-pdf .wy-pdf-container::-webkit-scrollbar {
  height: 0.625rem;
  width: 0.625rem;
  background: transparent;
  z-index: 999;
}
.wy-scrollbars .wy-content-pdf .wy-pdf-container::-webkit-scrollbar-track {
  background: transparent;
}
.wy-scrollbars .wy-content-pdf .wy-pdf-container::-webkit-scrollbar-thumb {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  border: 0.125rem solid transparent;
  border-radius: 0.5rem;
  background-clip: padding-box;
  opacity: 75%;
}
.wy-scrollbars .wy-content-pdf .wy-pdf-container::-webkit-scrollbar-thumb:hover {
  background-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  opacity: 75%;
}
.wy-scrollbars .wy-content-pdf .wy-pdf-container::-webkit-scrollbar-thumb:window-inactive {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  opacity: 50%;
}
@supports (overflow-y: overlay) {
  .wy-scrollbars .wy-content-pdf .wy-pdf-container {
    overflow-y: overlay;
  }
}
.wy-content-pdf .textLayer {
  position: absolute;
  text-align: initial;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0.25;
  line-height: 1;
  -webkit-text-size-adjust: none;
  -moz-text-size-adjust: none;
  text-size-adjust: none;
  forced-color-adjust: none;
}
.wy-content-pdf .textLayer span,
.wy-content-pdf .textLayer br {
  color: transparent;
  position: absolute;
  white-space: pre;
  cursor: text;
  transform-origin: 0% 0%;
}
.wy-content-pdf .textLayer span.markedContent {
  top: 0;
  height: 0;
}
.wy-content-pdf .textLayer .highlight {
  margin: -1px;
  padding: 1px;
  background-color: rgb(180, 0, 170);
  border-radius: 4px;
}
.wy-content-pdf .textLayer .highlight.appended {
  position: initial;
}
.wy-content-pdf .textLayer .highlight.begin {
  border-radius: 4px 0 0 4px;
}
.wy-content-pdf .textLayer .highlight.end {
  border-radius: 0 4px 4px 0;
}
.wy-content-pdf .textLayer .highlight.middle {
  border-radius: 0;
}
.wy-content-pdf .textLayer .highlight.selected {
  background-color: rgb(0, 100, 0);
}
.wy-content-pdf .textLayer ::-moz-selection {
  background: blue;
  background: AccentColor;
}
.wy-content-pdf .textLayer ::selection {
  background: blue;
  background: AccentColor;
}
.wy-content-pdf .textLayer br::-moz-selection {
  background: transparent;
}
.wy-content-pdf .textLayer br::selection {
  background: transparent;
}
.wy-content-pdf .textLayer .endOfContent {
  display: block;
  position: absolute;
  left: 0;
  top: 100%;
  right: 0;
  bottom: 0;
  z-index: -1;
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.wy-content-pdf .textLayer .endOfContent.active {
  top: 0;
}
@media (forced-colors: active) {
  .wy-content-pdf .annotationLayer .textWidgetAnnotation input:required,
  .wy-content-pdf .annotationLayer .textWidgetAnnotation textarea:required,
  .wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:required,
  .wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:required,
  .wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input:required {
    outline: 1.5px solid selectedItem;
  }
}
.wy-content-pdf .annotationLayer {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  transform-origin: 0 0;
}
.wy-content-pdf .annotationLayer section {
  position: absolute;
  text-align: initial;
  pointer-events: auto;
  box-sizing: border-box;
  transform-origin: 0 0;
}
.wy-content-pdf .annotationLayer .linkAnnotation > a,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.pushButton > a {
  position: absolute;
  font-size: 1em;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.pushButton > canvas {
  width: 100%;
  height: 100%;
}
.wy-content-pdf .annotationLayer .linkAnnotation > a:hover,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.pushButton > a:hover {
  opacity: 0.2;
  background: rgb(255, 255, 0);
  box-shadow: 0 2px 10px rgb(255, 255, 0);
}
.wy-content-pdf .annotationLayer .textAnnotation img {
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input,
.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea,
.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input {
  background-image: var(--annotation-unfocused-field-background);
  border: 2px solid var(--input-unfocused-border-color);
  box-sizing: border-box;
  font: calc(9px * var(--scale-factor)) sans-serif;
  height: 100%;
  margin: 0;
  vertical-align: top;
  width: 100%;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input:required,
.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea:required,
.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:required,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:required,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input:required {
  outline: 1.5px solid red;
}
.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select option {
  padding: 0;
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input {
  border-radius: 50%;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea {
  resize: none;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input[disabled],
.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea[disabled],
.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select[disabled],
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input[disabled],
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input[disabled] {
  background: none;
  border: 2px solid var(--input-disabled-border-color);
  cursor: not-allowed;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input:hover,
.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea:hover,
.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:hover,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:hover,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input:hover {
  border: 2px solid var(--input-hover-border-color);
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input:hover,
.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea:hover,
.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:hover,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:hover {
  border-radius: 2px;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input:focus,
.wy-content-pdf .annotationLayer .textWidgetAnnotation textarea:focus,
.wy-content-pdf .annotationLayer .choiceWidgetAnnotation select:focus {
  background: none;
  border: 2px solid var(--input-focus-border-color);
  border-radius: 2px;
  outline: var(--input-focus-outline);
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox :focus,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton :focus {
  background-image: none;
  background-color: transparent;
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox :focus {
  border: 2px solid var(--input-focus-border-color);
  border-radius: 2px;
  outline: var(--input-focus-outline);
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton :focus {
  border: 2px solid var(--input-focus-border-color);
  outline: var(--input-focus-outline);
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input:checked:before {
  background-color: CanvasText;
  content: "";
  display: block;
  position: absolute;
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after {
  height: 80%;
  left: 45%;
  width: 1px;
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before {
  transform: rotate(45deg);
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after {
  transform: rotate(-45deg);
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input:checked:before {
  border-radius: 50%;
  height: 50%;
  left: 30%;
  top: 20%;
  width: 50%;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input.comb {
  font-family: monospace;
  padding-left: 2px;
  padding-right: 0;
}
.wy-content-pdf .annotationLayer .textWidgetAnnotation input.comb:focus {
  /*
   * Letter spacing is placed on the right side of each character. Hence, the
   * letter spacing of the last character may be placed outside the visible
   * area, causing horizontal scrolling. We avoid this by extending the width
   * when the element has focus and revert this when it loses focus.
   */
  width: 103%;
}
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.checkBox input,
.wy-content-pdf .annotationLayer .buttonWidgetAnnotation.radioButton input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.wy-content-pdf .annotationLayer .popupTriggerArea {
  height: 100%;
  width: 100%;
}
.wy-content-pdf .annotationLayer .popupWrapper {
  position: absolute;
  font-size: calc(9px * var(--scale-factor));
  width: 100%;
  min-width: calc(180px * var(--scale-factor));
  pointer-events: none;
}
.wy-content-pdf .annotationLayer .popup {
  position: absolute;
  max-width: calc(180px * var(--scale-factor));
  background-color: rgb(255, 255, 153);
  box-shadow: 0 calc(2px * var(--scale-factor)) calc(5px * var(--scale-factor)) rgb(136, 136, 136);
  border-radius: calc(2px * var(--scale-factor));
  padding: calc(6px * var(--scale-factor));
  margin-left: calc(5px * var(--scale-factor));
  cursor: pointer;
  font: message-box;
  white-space: normal;
  word-wrap: break-word;
  pointer-events: auto;
}
.wy-content-pdf .annotationLayer .popup > * {
  font-size: calc(9px * var(--scale-factor));
}
.wy-content-pdf .annotationLayer .popup h1 {
  display: inline-block;
}
.wy-content-pdf .annotationLayer .popupDate {
  display: inline-block;
  margin-left: calc(5px * var(--scale-factor));
}
.wy-content-pdf .annotationLayer .popupContent {
  border-top: 1px solid rgb(51, 51, 51);
  margin-top: calc(2px * var(--scale-factor));
  padding-top: calc(2px * var(--scale-factor));
}
.wy-content-pdf .annotationLayer .richText > * {
  white-space: pre-wrap;
  font-size: calc(9px * var(--scale-factor));
}
.wy-content-pdf .annotationLayer .highlightAnnotation,
.wy-content-pdf .annotationLayer .underlineAnnotation,
.wy-content-pdf .annotationLayer .squigglyAnnotation,
.wy-content-pdf .annotationLayer .strikeoutAnnotation,
.wy-content-pdf .annotationLayer .freeTextAnnotation,
.wy-content-pdf .annotationLayer .lineAnnotation svg line,
.wy-content-pdf .annotationLayer .squareAnnotation svg rect,
.wy-content-pdf .annotationLayer .circleAnnotation svg ellipse,
.wy-content-pdf .annotationLayer .polylineAnnotation svg polyline,
.wy-content-pdf .annotationLayer .polygonAnnotation svg polygon,
.wy-content-pdf .annotationLayer .caretAnnotation,
.wy-content-pdf .annotationLayer .inkAnnotation svg polyline,
.wy-content-pdf .annotationLayer .stampAnnotation,
.wy-content-pdf .annotationLayer .fileAttachmentAnnotation {
  cursor: pointer;
}
.wy-content-pdf .annotationLayer section svg {
  position: absolute;
  width: 100%;
  height: 100%;
}
.wy-content-pdf .annotationLayer .annotationTextContent {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  color: transparent;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  pointer-events: none;
}
.wy-content-pdf .annotationLayer .annotationTextContent span {
  width: 100%;
  display: inline-block;
}
@media (forced-colors: active) {
  .wy-content-pdf .xfaLayer *:required {
    outline: 1.5px solid selectedItem;
  }
}
.wy-content-pdf .xfaLayer {
  background-color: transparent;
}
.wy-content-pdf .xfaLayer .highlight {
  margin: -1px;
  padding: 1px;
  background-color: rgb(239, 203, 237);
  border-radius: 4px;
}
.wy-content-pdf .xfaLayer .highlight.appended {
  position: initial;
}
.wy-content-pdf .xfaLayer .highlight.begin {
  border-radius: 4px 0 0 4px;
}
.wy-content-pdf .xfaLayer .highlight.end {
  border-radius: 0 4px 4px 0;
}
.wy-content-pdf .xfaLayer .highlight.middle {
  border-radius: 0;
}
.wy-content-pdf .xfaLayer .highlight.selected {
  background-color: rgb(203, 223, 203);
}
.wy-content-pdf .xfaPage {
  overflow: hidden;
  position: relative;
}
.wy-content-pdf .xfaContentarea {
  position: absolute;
}
.wy-content-pdf .xfaPrintOnly {
  display: none;
}
.wy-content-pdf .xfaLayer {
  position: absolute;
  text-align: initial;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  line-height: 1.2;
}
.wy-content-pdf .xfaLayer * {
  color: inherit;
  font: inherit;
  font-style: inherit;
  font-weight: inherit;
  font-kerning: inherit;
  letter-spacing: -0.01px;
  text-align: inherit;
  text-decoration: inherit;
  box-sizing: border-box;
  background-color: transparent;
  padding: 0;
  margin: 0;
  pointer-events: auto;
  line-height: inherit;
}
.wy-content-pdf .xfaLayer *:required {
  outline: 1.5px solid red;
}
.wy-content-pdf .xfaLayer div {
  pointer-events: none;
}
.wy-content-pdf .xfaLayer svg {
  pointer-events: none;
}
.wy-content-pdf .xfaLayer svg * {
  pointer-events: none;
}
.wy-content-pdf .xfaLayer a {
  color: blue;
}
.wy-content-pdf .xfaRich li {
  margin-left: 3em;
}
.wy-content-pdf .xfaFont {
  color: black;
  font-weight: normal;
  font-kerning: none;
  font-size: 10px;
  font-style: normal;
  letter-spacing: 0;
  text-decoration: none;
  vertical-align: 0;
}
.wy-content-pdf .xfaCaption {
  overflow: hidden;
  flex: 0 0 auto;
}
.wy-content-pdf .xfaCaptionForCheckButton {
  overflow: hidden;
  flex: 1 1 auto;
}
.wy-content-pdf .xfaLabel {
  height: 100%;
  width: 100%;
}
.wy-content-pdf .xfaLeft {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.wy-content-pdf .xfaRight {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}
.wy-content-pdf .xfaLeft > .xfaCaption,
.wy-content-pdf .xfaLeft > .xfaCaptionForCheckButton,
.wy-content-pdf .xfaRight > .xfaCaption,
.wy-content-pdf .xfaRight > .xfaCaptionForCheckButton {
  max-height: 100%;
}
.wy-content-pdf .xfaTop {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.wy-content-pdf .xfaBottom {
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
}
.wy-content-pdf .xfaTop > .xfaCaption,
.wy-content-pdf .xfaTop > .xfaCaptionForCheckButton,
.wy-content-pdf .xfaBottom > .xfaCaption,
.wy-content-pdf .xfaBottom > .xfaCaptionForCheckButton {
  width: 100%;
}
.wy-content-pdf .xfaBorder {
  background-color: transparent;
  position: absolute;
  pointer-events: none;
}
.wy-content-pdf .xfaWrapped {
  width: 100%;
  height: 100%;
}
.wy-content-pdf .xfaTextfield:focus,
.wy-content-pdf .xfaSelect:focus {
  background-image: none;
  background-color: transparent;
  outline: var(--xfa-focus-outline);
  outline-offset: -1px;
}
.wy-content-pdf .xfaCheckbox:focus,
.wy-content-pdf .xfaRadio:focus {
  outline: var(--xfa-focus-outline);
}
.wy-content-pdf .xfaTextfield,
.wy-content-pdf .xfaSelect {
  height: 100%;
  width: 100%;
  flex: 1 1 auto;
  border: none;
  resize: none;
  background-image: var(--xfa-unfocused-field-background);
}
.wy-content-pdf .xfaSelect {
  padding-left: 2px;
  padding-right: 2px;
  padding-inline: 2px;
}
.wy-content-pdf .xfaTop > .xfaTextfield,
.wy-content-pdf .xfaTop > .xfaSelect,
.wy-content-pdf .xfaBottom > .xfaTextfield,
.wy-content-pdf .xfaBottom > .xfaSelect {
  flex: 0 1 auto;
}
.wy-content-pdf .xfaButton {
  cursor: pointer;
  width: 100%;
  height: 100%;
  border: none;
  text-align: center;
}
.wy-content-pdf .xfaLink {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.wy-content-pdf .xfaCheckbox,
.wy-content-pdf .xfaRadio {
  width: 100%;
  height: 100%;
  flex: 0 0 auto;
  border: none;
}
.wy-content-pdf .xfaRich {
  white-space: pre-wrap;
  width: 100%;
  height: 100%;
}
.wy-content-pdf .xfaImage {
  -o-object-position: left top;
  object-position: left top;
  -o-object-fit: contain;
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.wy-content-pdf .xfaLrTb,
.wy-content-pdf .xfaRlTb,
.wy-content-pdf .xfaTb {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.wy-content-pdf .xfaLr {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
.wy-content-pdf .xfaRl {
  display: flex;
  flex-direction: row-reverse;
  align-items: stretch;
}
.wy-content-pdf .xfaTb > div {
  justify-content: left;
}
.wy-content-pdf .xfaPosition {
  position: relative;
}
.wy-content-pdf .xfaArea {
  position: relative;
}
.wy-content-pdf .xfaValignMiddle {
  display: flex;
  align-items: center;
}
.wy-content-pdf .xfaTable {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.wy-content-pdf .xfaTable .xfaRow {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
.wy-content-pdf .xfaTable .xfaRlRow {
  display: flex;
  flex-direction: row-reverse;
  align-items: stretch;
  flex: 1;
}
.wy-content-pdf .xfaTable .xfaRlRow > div {
  flex: 1;
}
.wy-content-pdf .xfaNonInteractive input,
.wy-content-pdf .xfaNonInteractive textarea,
.wy-content-pdf .xfaDisabled input,
.wy-content-pdf .xfaDisabled textarea,
.wy-content-pdf .xfaReadOnly input,
.wy-content-pdf .xfaReadOnly textarea {
  background: initial;
}
@media print {
  .wy-content-pdf .xfaTextfield,
  .wy-content-pdf .xfaSelect {
    background: transparent;
  }
  .wy-content-pdf .xfaSelect {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    text-indent: 1px;
    text-overflow: "";
  }
}
.wy-content-pdf [data-editor-rotation="90"] {
  transform: rotate(90deg);
}
.wy-content-pdf [data-editor-rotation="180"] {
  transform: rotate(180deg);
}
.wy-content-pdf [data-editor-rotation="270"] {
  transform: rotate(270deg);
}
.wy-content-pdf .annotationEditorLayer {
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  font-size: calc(100px * var(--scale-factor));
  transform-origin: 0 0;
  cursor: auto;
  z-index: 20000;
}
.wy-content-pdf .annotationEditorLayer.freeTextEditing {
  cursor: var(--editorFreeText-editing-cursor);
}
.wy-content-pdf .annotationEditorLayer.inkEditing {
  cursor: var(--editorInk-editing-cursor);
}
.wy-content-pdf .annotationEditorLayer .selectedEditor {
  outline: var(--focus-outline);
  resize: none;
}
.wy-content-pdf .annotationEditorLayer .freeTextEditor {
  position: absolute;
  background: transparent;
  border-radius: 3px;
  padding: calc(var(--freetext-padding) * var(--scale-factor));
  resize: none;
  width: auto;
  height: auto;
  z-index: 1;
  transform-origin: 0 0;
  touch-action: none;
  cursor: auto;
}
.wy-content-pdf .annotationEditorLayer .freeTextEditor .internal {
  background: transparent;
  border: none;
  top: 0;
  left: 0;
  overflow: visible;
  white-space: nowrap;
  resize: none;
  font: 10px sans-serif;
  line-height: var(--freetext-line-height);
}
.wy-content-pdf .annotationEditorLayer .freeTextEditor .overlay {
  position: absolute;
  display: none;
  background: transparent;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.wy-content-pdf .annotationEditorLayer .freeTextEditor .overlay.enabled {
  display: block;
}
.wy-content-pdf .annotationEditorLayer .freeTextEditor .internal:empty::before {
  content: attr(default-content);
  color: gray;
}
.wy-content-pdf .annotationEditorLayer .freeTextEditor .internal:focus {
  outline: none;
}
.wy-content-pdf .annotationEditorLayer .inkEditor.disabled {
  resize: none;
}
.wy-content-pdf .annotationEditorLayer .inkEditor.disabled.selectedEditor {
  resize: horizontal;
}
.wy-content-pdf .annotationEditorLayer .freeTextEditor:hover:not(.selectedEditor),
.wy-content-pdf .annotationEditorLayer .inkEditor:hover:not(.selectedEditor) {
  outline: var(--hover-outline);
}
.wy-content-pdf .annotationEditorLayer .inkEditor {
  position: absolute;
  background: transparent;
  border-radius: 3px;
  overflow: auto;
  width: 100%;
  height: 100%;
  z-index: 1;
  transform-origin: 0 0;
  cursor: auto;
}
.wy-content-pdf .annotationEditorLayer .inkEditor.editing {
  resize: none;
  cursor: inherit;
}
.wy-content-pdf .annotationEditorLayer .inkEditor .inkEditorCanvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  touch-action: none;
}
.wy-content-pdf [data-main-rotation="90"] {
  transform: rotate(90deg) translateY(-100%);
}
.wy-content-pdf [data-main-rotation="180"] {
  transform: rotate(180deg) translate(-100%, -100%);
}
.wy-content-pdf [data-main-rotation="270"] {
  transform: rotate(270deg) translateX(-100%);
}
.wy-content-pdf .pdfViewer {
  padding-bottom: var(--pdfViewer-padding-bottom);
}
.wy-content-pdf .pdfViewer .canvasWrapper {
  overflow: hidden;
}
.wy-content-pdf .pdfViewer .page {
  direction: ltr;
  width: 816px;
  height: 1056px;
  margin: var(--page-margin);
  position: relative;
  overflow: visible;
  border: var(--page-border);
  -o-border-image: var(--page-border-image);
  border-image: var(--page-border-image);
  background-clip: content-box;
  background-color: rgb(255, 255, 255);
}
.wy-content-pdf .pdfViewer .dummyPage {
  position: relative;
  width: 0;
  height: var(--viewer-container-height);
}
.wy-content-pdf .pdfViewer.removePageBorders .page {
  margin: 0 auto 10px;
  border: none;
}
.wy-content-pdf .pdfViewer.singlePageView {
  display: inline-block;
}
.wy-content-pdf .pdfViewer.singlePageView .page {
  margin: 0;
  border: none;
}
.wy-content-pdf .pdfViewer.scrollHorizontal,
.wy-content-pdf .pdfViewer.scrollWrapped,
.wy-content-pdf .spread {
  margin-left: 3.5px;
  margin-right: 3.5px;
  text-align: center;
}
.wy-content-pdf .pdfViewer.scrollHorizontal,
.wy-content-pdf .spread {
  white-space: nowrap;
}
.wy-content-pdf .pdfViewer.removePageBorders,
.wy-content-pdf .pdfViewer.scrollHorizontal .spread,
.wy-content-pdf .pdfViewer.scrollWrapped .spread {
  margin-left: 0;
  margin-right: 0;
}
.wy-content-pdf .spread .page,
.wy-content-pdf .spread .dummyPage,
.wy-content-pdf .pdfViewer.scrollHorizontal .page,
.wy-content-pdf .pdfViewer.scrollWrapped .page,
.wy-content-pdf .pdfViewer.scrollHorizontal .spread,
.wy-content-pdf .pdfViewer.scrollWrapped .spread {
  display: inline-block;
  vertical-align: middle;
}
.wy-content-pdf .spread .page,
.wy-content-pdf .pdfViewer.scrollHorizontal .page,
.wy-content-pdf .pdfViewer.scrollWrapped .page {
  margin-left: var(--spreadHorizontalWrapped-margin-LR);
  margin-right: var(--spreadHorizontalWrapped-margin-LR);
}
.wy-content-pdf .pdfViewer.removePageBorders .spread .page,
.wy-content-pdf .pdfViewer.removePageBorders.scrollHorizontal .page,
.wy-content-pdf .pdfViewer.removePageBorders.scrollWrapped .page {
  margin-left: 5px;
  margin-right: 5px;
}
.wy-content-pdf .pdfViewer .page canvas {
  margin: 0;
  display: block;
}
.wy-content-pdf .pdfViewer .page canvas[hidden] {
  display: none;
}
.wy-content-pdf .pdfViewer .page .loadingIcon {
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.wy-content-pdf .pdfViewer .page .loadingIcon.notVisible {
  background: none;
}
.wy-content-pdf .pdfViewer.enablePermissions .textLayer span {
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  user-select: none !important;
  cursor: not-allowed;
}
.wy-content-pdf .pdfPresentationMode .pdfViewer {
  padding-bottom: 0;
}
.wy-content-pdf .pdfPresentationMode .spread {
  margin: 0;
}
.wy-content-pdf .pdfPresentationMode .pdfViewer .page {
  margin: 0 auto;
  border: 2px solid transparent;
}
.wy-content-pdf .pdfViewer .page {
  box-shadow: var(--wy-shadow-level2, 0 0.25rem 0.3125rem 0 rgba(0, 0, 0, 0.14), 0 0.0625rem 0.625rem 0 rgba(0, 0, 0, 0.12), 0 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.2));
  background-color: var(--wy-white, var(, ));
}

.wy-content-text {
  word-break: break-word;
  white-space: pre-wrap;
}

.wy-likes {
  display: inline-flex;
  align-items: center;
}

.wy-like-button {
  background: var(--wy-component-background-color);
  color: var(--wy-primary);
  width: 2.5rem;
  height: 2.5rem;
}

.wy-like-count {
  padding: 0 0.5rem;
  color: var(--wy-outline);
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
}

.wy-reaction-count {
  margin: 0 0.5rem 0 0.125rem;
  line-height: 1;
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
}

.wy-reaction-menu {
  padding: 0.25rem;
  font-size: 1.125rem;
  border-radius: 2.5rem;
}

.wy-reaction-picker {
  display: flex;
}
.wy-reaction-picker .wy-reaction-button {
  color: unset;
}

.wy-reactions {
  display: inline-flex;
  align-items: center;
  column-gap: 0.1875rem;
}
.wy-reactions:empty {
  display: none;
}

.wy-reactions-line {
  display: flex;
  align-items: center;
}

:host(wy-reactions) .wy-emoji {
  width: 1.125rem;
  height: 1.125rem;
  font-size: 1.125rem;
}
:host(wy-reactions) .wy-emoji:first-child {
  margin-left: 0.1875rem;
}
:host(wy-reactions) .wy-emoji:last-child {
  margin-right: 0.1875rem;
}

:host(wy-reactions[small]) .wy-reaction-lineup .wy-emoji, :host(wy-reactions[small]) .wy-reaction-like-button .wy-emoji {
  width: 1.125rem;
  height: 1.125rem;
  font-size: 1rem;
}
:host(wy-reactions[small]) .wy-reaction-lineup .wy-emoji:first-child, :host(wy-reactions[small]) .wy-reaction-like-button .wy-emoji:first-child {
  margin-left: 0.125rem;
}
:host(wy-reactions[small]) .wy-reaction-lineup .wy-emoji:last-child, :host(wy-reactions[small]) .wy-reaction-like-button .wy-emoji:last-child {
  margin-right: 0.125rem;
}
:host(wy-reactions[small]) .wy-reaction-lineup .wy-like-count, :host(wy-reactions[small]) .wy-reaction-like-button .wy-like-count {
  font-size: var(--wy-font-size-xs, calc(0.75 * var(--wy-font-size-base, 1rem)));
}

.wy-table-reactions td:first-child {
  width: 3rem;
}
.wy-table-reactions td:nth-child(2) {
  width: 100%;
}
.wy-table-reactions tr:last-child td {
  box-shadow: none;
}

.wy-reaction {
  font-size: 1.125rem;
}

.wy-reaction-menu-button, .wy-like-button {
  background: var(--wy-component-background-color);
  color: currentColor;
  border-radius: var(--wy-border-radius-pill, 50rem);
  background-clip: content-box;
}

.wy-sheet {
  --wy-scrollbar-adjust-top: 0;
  --wy-scrollbar-adjust-bottom: 0;
  --wy-component-background-color: var(--wy-surface-3, var(--wy-surface-3-light, #e3e7ee));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  position: fixed;
  z-index: 1055;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  bottom: 0.5rem;
  left: 0.5rem;
  right: 0.5rem;
  max-height: max(50vh, 50%);
  min-height: 3rem;
  margin: 0.5rem auto;
  max-width: 32rem;
  transition: opacity var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  border-radius: var(--wy-border-radius, 0.5rem);
  box-shadow: var(--wy-shadow-level1, 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.14), 0 0.1875rem 0.0625rem -0.125rem rgba(0, 0, 0, 0.2), 0 0.0625rem 0.3125rem 0 rgba(0, 0, 0, 0.12));
}
.wy-sheet > .wy-appbars, .wy-sheet > .wy-appbar {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.wy-sheet-body {
  overflow: hidden;
  padding: 0.5rem;
  position: relative;
  min-height: 3rem;
}
.wy-sheet-body.wy-scroll-y {
  overflow-y: auto;
}

.wy-sheet:not(.wy-show) {
  opacity: 0;
  transform: translateY(32rem);
}
.wy-sheet.wy-show {
  opacity: 1;
  transform: none;
  transition: transform var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))), opacity var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  pointer-events: auto;
}

.wy-spinner {
  align-self: center;
  justify-self: center;
  margin: auto;
}
.wy-spinner circle {
  stroke-dasharray: 1, 100;
  stroke-dashoffset: 0;
  transform-origin: center;
  fill: none !important;
}
.wy-spinner.wy-spin {
  animation: wy-rotate 1.4s linear infinite;
}
.wy-spinner.wy-spin circle {
  animation: wy-dash 1.4s ease-in-out infinite, wy-color 2.8s ease-in-out infinite;
}
.wy-spinner.wy-spinner-overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}

@keyframes wy-rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes wy-dash {
  0% {
    stroke-dasharray: 1, 100;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 44.5, 100;
    stroke-dashoffset: -17.5;
  }
  100% {
    stroke-dasharray: 44.5, 100;
    stroke-dashoffset: -62;
  }
}
@keyframes wy-color {
  0%, 100% {
    stroke: var(--wy-primary, var(--wy-primary-40, #006399));
  }
  25% {
    stroke: var(--wy-primary, var(--wy-primary-40, #006399));
  }
  50% {
    stroke: transparent;
  }
  75% {
    stroke: var(--wy-primary, var(--wy-primary-40, #006399));
  }
}
.wy-toasts {
  position: fixed;
  left: 0;
  bottom: 3.5rem;
  right: 0;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1030;
  gap: 1rem;
}

.wy-toast {
  background: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  margin: 0 0 1rem;
  width: 16rem;
  max-width: calc(100% - 3rem);
  gap: 0.5rem;
  display: flex;
  cursor: pointer;
  border-radius: var(--wy-border-radius, 0.5rem);
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0.5rem;
  padding: 0.5rem 0.75rem;
  user-select: none;
  box-shadow: var(--wy-shadow-level2, 0 0.25rem 0.3125rem 0 rgba(0, 0, 0, 0.14), 0 0.0625rem 0.625rem 0 rgba(0, 0, 0, 0.12), 0 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.2));
  position: relative;
  overflow: hidden;
  height: auto;
}
.wy-toast.wy-fade {
  transition: all var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
}
.wy-toast.wy-fade:not(.wy-show) {
  opacity: 0;
  height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.wy-toast-action {
  position: sticky;
  top: 4.5rem;
  bottom: 4.5rem;
  z-index: 990;
  background-color: var(--wy-primary, var(--wy-primary-40, #006399));
  color: var(--wy-on-primary, var(--wy-white, #ffffff));
  padding: 0.5rem 1rem;
  border-radius: var(--wy-border-radius-pill, 50rem);
  font-size: var(--wy-font-size-xs, calc(0.75 * var(--wy-font-size-base, 1rem)));
  width: max-content;
  align-self: center;
  text-align: center;
  box-shadow: none;
}

.wy-toast-primary {
  background: var(--wy-on-primary-container, var(--wy-primary-10, #001d32));
  color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
}

.wy-typing-show {
  font-style: italic;
  display: none;
}

.wy-typing-active .wy-typing-show {
  display: block;
}
.wy-typing-active .wy-typing-hide {
  display: none;
}

.wy-appbar wy-typing {
  position: relative;
  padding: 0 1.25rem;
}

.wy-placeholder {
  cursor: wait;
  color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  background: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  opacity: 0.5;
  animation: wy-placeholder-glow 2s ease-in-out infinite;
}

@keyframes wy-placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.wy-meeting {
  flex: 1 1 100%;
  align-items: flex-start;
}

.wy-meeting-actions {
  margin-top: 0.5rem;
}

.wy-dragging::after {
  content: attr(data-drag-title);
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed var(--wy-primary, var(--wy-primary-40, #006399));
  font-weight: 700;
  z-index: 10000;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/*
.wy-message-editor {
  background-color: color.token(--wy-surface-1);
}
*/
.wy-message-editor-top {
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}
@supports (position: sticky) {
  .wy-message-editor-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.wy-message-editor-bottom {
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}
@supports (position: sticky) {
  .wy-message-editor-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

.wy-message-form .wy-spinner {
  display: none;
}
.wy-message-form.wy-uploading .wy-spinner {
  display: block;
}
.wy-message-form.wy-uploading [data-icon=plus] {
  display: none;
}
.wy-message-form .wy-picker-list:not(:empty) {
  border-top: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}

.wy-message-editor-inputs {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 0.5rem 0.25rem;
  min-height: 3.5rem;
}
.wy-message-editor-inputs > :not(:last-child) {
  margin-right: 0.25rem;
}

.wy-message-editor-buttons {
  flex: 1 0 auto;
}

.wy-message-editor-text {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
}

.wy-message-editor-mention {
  background: blue;
  color: white;
}

.wy-message-editor-link {
  background: blue;
  color: white;
}

.wy-message-editor .ͼ1.cm-editor,
.wy-message-editor-grow::after,
.wy-message-editor-grow > textarea,
.wy-message-editor-textfield {
  flex: 1 1 100%;
  max-height: 11.25rem;
  background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  border-radius: 1.25rem;
  border: var(--wy-input-border-width, 1px) solid var(--wy-background, var(--wy-neutral-99, #fcfcff));
}
.wy-message-editor .ͼ1.cm-editor:focus,
.wy-message-editor-grow:focus::after,
.wy-message-editor-grow > textarea:focus,
.wy-message-editor-textfield:focus {
  border-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}

.wy-message-editor .ͼ1.cm-editor .cm-content,
.wy-message-editor-textcontent {
  font-family: var(--wy-input-font-family, var(--wy-font-family, inherit)),  inherit;
  font-size: var(--wy-font-size-base, 1rem);
  padding: var(--wy-input-padding-y, 0.4375rem) var(--wy-input-padding-x, 0.75rem);
}

.wy-message-editor-grow {
  display: grid;
}
.wy-message-editor-grow::after,
.wy-message-editor-grow > textarea {
  grid-area: 1/1/2/2;
}
.wy-message-editor-grow::after {
  content: attr(data-replicated-value) " ";
  white-space: pre-wrap;
  visibility: hidden;
}
.wy-message-editor-grow > textarea {
  resize: none;
  overflow: hidden;
}

.wy-message-editor .ͼ1 .cm-scroller {
  font-family: unset;
  line-height: 1.5;
}
.wy-message-editor .ͼ1 .cm-widgetBuffer {
  vertical-align: unset;
}
.wy-message-editor .ͼ1 .cm-placeholder {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
}
.wy-message-editor .ͼ2 .cm-content {
  caret-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
}
.wy-message-editor .ͼ1.cm-editor.cm-focused {
  /* default theme in codemirror seems difficult to override */
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  color: var(--wy-component-color);
  border-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  outline: 0;
}
.wy-message-editor .ͼ1.cm-editor .cm-scroller {
  overflow: auto;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller {
  scrollbar-width: thin;
  scrollbar-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e)) transparent;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar {
  height: 0.625rem;
  width: 0.625rem;
  background: transparent;
  z-index: 999;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-track {
  background: transparent;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  border: 0.125rem solid transparent;
  border-radius: 0.5rem;
  background-clip: padding-box;
  opacity: 75%;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb:hover {
  background-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  opacity: 75%;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb:window-inactive {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  opacity: 50%;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-button:vertical:start:single-button {
  height: 0.375rem;
}
.wy-scrollbars .wy-message-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-button:vertical:end:single-button {
  height: 0.375rem;
}
.wy-message-editor .wy-is-invalid + [data-editor-target] .cm-editor, .wy-message-editor .wy-is-invalid .cm-editor {
  border-color: var(--wy-error, var(--wy-error-40, #ba1824)) !important;
}
.wy-message-editor .ͼ1 .cm-tooltip.cm-tooltip-autocomplete > ul {
  font-family: unset;
  max-height: 15rem;
}
.wy-message-editor .ͼ1 .cm-tooltip.cm-tooltip-autocomplete > ul > li {
  padding: 0;
}
.wy-message-editor .ͼ2 .cm-tooltip {
  border: none;
  background-clip: padding-box;
  background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  border-radius: var(--wy-border-radius, 0.5rem);
  box-shadow: var(--wy-shadow-level1, 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.14), 0 0.1875rem 0.0625rem -0.125rem rgba(0, 0, 0, 0.2), 0 0.0625rem 0.3125rem 0 rgba(0, 0, 0, 0.12));
  overflow: hidden;
  z-index: 1000;
}
.wy-message-editor .ͼ2 .cm-tooltip-autocomplete ul li[aria-selected] {
  background: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
  color: unset;
}
.wy-message-editor .cm-tooltip-autocomplete .cm-completionLabel {
  display: none;
}
.wy-message-editor .cm-tooltip-autocomplete .wy-item-hover:hover, .wy-message-editor .cm-tooltip-autocomplete .wy-item-hover:focus {
  background: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
}
.wy-message-editor .cm-tooltip-autocomplete .wy-avatar {
  width: 32px;
  height: 32px;
}

.wy-messenger-conversation {
  ---background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  ---color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  background-color: var(---background-color);
  color: var(---color);
  overflow-anchor: none;
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  height: 100%;
}

.wy-card {
  --wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  --wy-component-border-radius: var(--wy-border-radius-lg, calc(1.5 * var(--wy-border-radius, 0.5rem)));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  border-radius: var(--wy-component-border-radius);
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-clip: border-box;
}
.wy-card > hr {
  margin-right: 0;
  margin-left: 0;
}

.wy-card-primary {
  --wy-component-background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
  --wy-component-color: var(--wy-on-primary-container, var(--wy-primary-10, #001d32));
}

.wy-card-hover {
  cursor: pointer;
  user-select: none;
}
.wy-card-hover::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background: var(--wy-component-color);
  opacity: 0%;
}
.wy-card-hover:hover::before {
  opacity: var(--wy-opacity-state-hover, 8%);
}
.wy-card-hover:focus::before {
  opacity: var(--wy-opacity-state-focus, 12%);
}
.wy-card-hover:active::before, .wy-card-hover.wy-active::before {
  opacity: var(--wy-opacity-state-active, 12%);
}

.wy-card-actions {
  position: absolute;
  top: min(0.25rem, 100% - 2.5rem);
  right: 0.25rem;
  align-items: center;
  display: flex;
}
.wy-card-actions > .wy-button-icon, .wy-card-actions > .wy-dropdown > .wy-button-icon {
  background-clip: content-box;
}

.wy-card-content {
  flex: 1 0 auto;
  padding-block-end: 0.5rem;
  padding-inline-start: 0.5rem;
  padding-inline-end: 0.5rem;
}
.wy-card-content:first-child, .wy-card-actions + .wy-card-content:nth-child(2) {
  padding-block-start: 0.5rem;
}

.wy-card-top {
  border-radius: var(--wy-component-border-radius);
  object-fit: cover;
  object-position: top center;
  flex: 1 1 100%;
  max-height: 10rem;
}

.wy-card-top-image {
  object-position: 50% 38%;
}

.wy-card-trashed {
  text-decoration: line-through;
}
.wy-card-trashed > *:not(.wy-card-actions) {
  opacity: var(--wy-opacity-disabled, 38%);
}

.wy-filename {
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

.wy-files {
  width: 100%;
  height: 100%;
  position: relative;
  color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  display: flex;
  flex-direction: column;
  flex: 1;
}

@supports (position: sticky) {
  wy-files-appbar {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.wy-table-files thead {
  display: none;
  text-align: left;
}
.wy-table-files td:nth-child(2) {
  padding: 0 var(--wy-table-cell-padding-x, 0.25rem);
}
.wy-table-files td:nth-child(2),
.wy-table-files th:nth-child(2) {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wy-table-files td:nth-child(3),
.wy-table-files th:nth-child(3) {
  display: none;
  width: 7rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wy-table-files td:nth-child(4),
.wy-table-files th:nth-child(4) {
  display: none;
  width: 7.5rem;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wy-table-files td:nth-child(5),
.wy-table-files th:nth-child(5) {
  display: none;
  width: 7rem;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (min-width: 576px) {
  .wy-table-files thead {
    display: table-header-group;
  }
  .wy-table-files td:nth-child(5),
  .wy-table-files th:nth-child(5) {
    display: table-cell;
  }
}
@media (min-width: 768px) {
  .wy-table-files td:nth-child(3),
  .wy-table-files th:nth-child(3),
  .wy-table-files td:nth-child(4),
  .wy-table-files th:nth-child(4) {
    display: table-cell;
  }
}

.wy-files-thead {
  text-align: left;
}
@media (max-width: 767.98px) {
  .wy-files-thead {
    display: none;
  }
}

.wy-files-td-filename {
  padding: 0 var(--wy-table-cell-padding-x, 0.25rem);
}

.wy-files-td-filename,
.wy-files-th-filename {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wy-files-td-modified,
.wy-files-th-modified {
  width: 7rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 991.98px) {
  .wy-files-td-modified,
  .wy-files-th-modified {
    display: none;
  }
}

.wy-files-td-kind,
.wy-files-th-kind {
  width: 7.5rem;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 991.98px) {
  .wy-files-td-kind,
  .wy-files-th-kind {
    display: none;
  }
}

.wy-files-td-size,
.wy-files-th-size {
  width: 7rem;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (min-width: 768px) {
  .wy-files-td-size,
  .wy-files-th-size {
    display: none;
  }
}

.wy-grid {
  display: grid;
  grid-auto-flow: dense;
  grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr));
  grid-gap: 0.75rem;
}

.wy-sidebar {
  --wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background: var(--wy-component-background-color);
  color: var(--wy-component-color);
  min-width: 0;
  min-height: 0;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 18rem;
  z-index: 10;
  display: flex;
  flex-direction: column;
  transition: flex-basis var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  position: relative;
  order: 9999;
}
.wy-sidebar > * {
  transition: opacity var(--wy-transition-fast, var(--wy-transition-duration-fast, 0.1s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))) calc(var(--wy-transition-duration, 0.2s) - var(--wy-transition-duration-fast, 0.1s));
  min-width: 18rem;
}
.wy-sidebar[hidden] {
  display: flex !important;
  flex-basis: 0;
}
.wy-sidebar[hidden] > * {
  transition: opacity var(--wy-transition-fast, var(--wy-transition-duration-fast, 0.1s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
  opacity: 0;
}
@media (min-width: 768px) {
  .wy-sidebar > * {
    min-width: 18rem;
  }
  .wy-sidebar .wy-sidebar-handle {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .wy-sidebar {
    transition: flex-basis var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1))), margin-top var(--wy-transition, var(--wy-transition-duration, 0.2s) var(--wy-transition-curve, cubic-bezier(0.4, 0, 0.2, 1)));
    border-top-left-radius: var(--wy-border-radius-lg, calc(1.5 * var(--wy-border-radius, 0.5rem)));
    border-top-right-radius: var(--wy-border-radius-lg, calc(1.5 * var(--wy-border-radius, 0.5rem)));
    flex-basis: 50vh;
  }
  .wy-sidebar:not([hidden]) {
    margin-top: calc(-1 * var(--wy-border-radius-lg, calc(1.5 * var(--wy-border-radius, 0.5rem))));
  }
  .wy-sidebar:not([hidden]).wy-maximized {
    flex-basis: calc(100% - var(--wy-appbar-height, 3rem) * .5);
    margin-top: calc(-50% + var(--wy-appbar-height, 3rem) * 2.5 - var(--wy-border-radius-lg, calc(1.5 * var(--wy-border-radius, 0.5rem))));
  }
  .wy-sidebar:not([hidden]).wy-maximized ~ * .wy-nav-prev,
  .wy-sidebar:not([hidden]).wy-maximized ~ * .wy-nav-next {
    display: none;
  }
  .wy-sidebar > * {
    min-height: var(--wy-appbar-height, 3rem);
  }
}

.wy-sidebar-handle {
  width: 4rem;
  background-clip: content-box;
  background-color: var(--wy-on-surface-variant, var(--wy-neutral-variant-30, #42474e));
  height: 1rem;
  border: 0.375rem solid transparent;
  position: absolute;
  top: 0rem;
  z-index: 2;
  left: 50%;
  margin-left: -2rem;
  border-radius: var(--wy-border-radius-pill, 50rem);
  cursor: pointer;
}

.wy-table {
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  --wy-component-background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  color: var(--wy-component-color);
  background-color: var(--wy-component-background-color);
  table-layout: fixed;
  width: 100%;
  vertical-align: top;
  border-collapse: collapse;
}
.wy-table th, .wy-table td {
  padding: var(--wy-table-cell-padding-y, 0.25rem) var(--wy-table-cell-padding-x, 0.25rem);
  box-shadow: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce)) 0px -1px 0px 0px inset;
  line-height: 1;
  vertical-align: middle;
  height: 2.5rem;
}
.wy-table th:first-child, .wy-table td:first-child {
  padding-left: calc(var(--wy-table-cell-padding-x, 0.25rem) * 2);
}
.wy-table th:last-child, .wy-table td:last-child {
  padding-right: calc(var(--wy-table-cell-padding-x, 0.25rem) * 2);
}
.wy-table > tbody {
  vertical-align: inherit;
}
.wy-table > thead {
  vertical-align: bottom;
}
.wy-table .wy-table-cell-icon {
  color: var(--wy-component-color);
  vertical-align: middle;
  text-align: center;
  padding: calc(var(--wy-table-cell-padding-y, 0.25rem) * .5) var(--wy-table-cell-padding-x, 0.25rem);
  width: calc(2.5rem + var(--wy-table-cell-padding-x, 0.25rem) * 2);
  font-size: var(--wy-font-size-base, 1rem);
  font-weight: var(--wy-font-weight-base, );
  text-transform: none;
  letter-spacing: normal;
}
.wy-table .wy-table-cell-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.wy-table-hover > tbody > tr:not(.wy-pager):hover > * {
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  --wy-component-background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  color: var(--color);
  background-color: var(--wy-component-background-color);
  cursor: pointer;
}

.wy-table-trashed th, .wy-table-trashed td {
  text-decoration: line-through;
}
.wy-table-trashed th:not(:last-child) > *, .wy-table-trashed td:not(:last-child) > * {
  opacity: var(--wy-opacity-disabled, 38%);
}
.wy-table-trashed th > a, .wy-table-trashed td > a {
  color: var(--wy-component-color);
}
.wy-table-trashed:hover th, .wy-table-trashed:hover td {
  opacity: 1;
}

.wy-table-no-result {
  text-align: center;
  padding: 1rem;
}

.wy-table-sort-link {
  display: inline-flex;
  align-items: center;
  color: var(--wy-link, var(--wy-primary-40, #006399));
  cursor: pointer;
}

.wy-post {
  --wy-component-background-color: var(--wy-surface-1, var(--wy-surface-1-light, #f1f2f7));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 1rem 0.75rem;
  --wy-component-border-radius: var(--wy-border-radius, 0.5rem);
  border-radius: var(--wy-component-border-radius);
}
.wy-post .wy-image-grid {
  border-radius: 0;
  margin-bottom: 1rem;
}
.wy-post .wy-embed {
  margin-bottom: 1rem;
}
.wy-post .wy-comments {
  margin: 0.5rem 0.75rem;
  border-top: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  padding: 0.75rem 0 0;
}

.wy-post-body {
  padding: 0 1rem;
}
.wy-post-body:empty {
  display: none;
}
.wy-post-body .wy-content, .wy-post-body .wy-list, .wy-post-body .wy-poll {
  margin-bottom: 1rem;
}

.wy-post-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0.25rem 0.25rem;
}
.wy-post-footer .wy-meta {
  margin-right: 0.5rem;
}

.wy-post-dragging::after {
  content: attr(data-drag-title, "Drop files here to upload.");
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed var(--wy-primary, var(--wy-primary-40, #006399));
  font-weight: 700;
  z-index: 10000;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.wy-poll {
  flex: 1 1 100%;
  min-width: 0;
}

.wy-poll-form {
  background: var(--wy-component-background-color);
  color: var(--wy-component-color);
  padding: 0.5rem;
}
.wy-poll-form:empty {
  display: none;
}
.wy-poll-form input:not(:first-child) {
  margin-top: 0.5rem;
}

.wy-poll-option {
  position: relative;
  background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  border: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  border-radius: var(--wy-border-radius-sm, calc(0.75 * var(--wy-border-radius, 0.5rem)));
  margin-bottom: 0.25rem;
  padding: 0.25rem 0.5rem;
  min-height: 2.5rem;
  cursor: pointer;
}
.wy-poll-option .wy-progress {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
}
.wy-poll-option > :not(.wy-progress) {
  z-index: 1;
}

.wy-embed {
  display: flex;
  flex-direction: column;
  word-wrap: break-word;
}

.wy-embed-photo a {
  display: flex;
}
.wy-embed-photo img {
  width: 100%;
  height: auto;
}

.wy-embed-photo-sm a {
  padding: 0 1rem;
}
.wy-embed-photo-sm img {
  display: block;
  margin: 0 auto;
  width: auto;
  max-width: 100%;
  border-radius: var(--wy-border-radius-sm, calc(0.75 * var(--wy-border-radius, 0.5rem)));
}

.wy-embed-video {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.wy-embed-video::before {
  display: block;
  content: "";
  padding-top: 56.25%;
}
.wy-embed-video iframe, .wy-embed-video embed, .wy-embed-video object, .wy-embed-video video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.wy-embed-caption {
  --wy-component-background-color: var(--wy-surface-3, var(--wy-surface-3-light, #e3e7ee));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  padding: 0.5rem 1rem 1rem;
  position: relative;
}

.wy-embed-link {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  text-transform: uppercase;
  font-size: var(--wy-font-size-sm, calc(0.875 * var(--wy-font-size-base, 1rem)));
}
.wy-embed-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.wy-embed-title {
  font-weight: var(--wy-headings-font-weight, 500);
  margin-bottom: 0.5rem;
}

.wy-embed-description {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
}

.wy-embed-preview a[target=_blank] {
  pointer-events: none;
}
.wy-embed-preview .wy-embed {
  display: none;
  margin: 0.75rem;
  border: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  border-radius: var(--wy-border-radius, 0.5rem);
}
.wy-embed-preview .wy-embed:first-child {
  display: block;
}
.wy-embed-preview .wy-embed-caption {
  border-bottom-left-radius: var(--wy-border-radius, 0.5rem);
  border-bottom-right-radius: var(--wy-border-radius, 0.5rem);
}
.wy-embed-preview .wy-embed-actions {
  display: flex;
}

.wy-embed-actions {
  display: none;
  justify-content: space-between;
  padding: 0.5rem 0.25rem;
}

.wy-embed-cycle {
  visibility: hidden;
}
.wy-embed-show-cycle .wy-embed-cycle {
  visibility: visible;
}

.wy-post-editor {
  padding: 0.75rem;
}
.wy-post-editor.wy-uploading .wy-icon-active-stack > :first-child {
  opacity: 0;
}
.wy-post-editor.wy-uploading .wy-icon-active-stack > :last-child {
  opacity: 1;
}
.wy-post-editor .wy-picker-list:not(:empty) {
  margin-top: 0.75rem;
  border-top: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}

.wy-post-editor-inputs {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  min-height: 3.5rem;
  flex-wrap: wrap;
}
.wy-post-editor-inputs > :not(:last-child) {
  margin-right: 0.25rem;
}
.wy-post-editor-inputs > :last-child {
  margin-left: auto;
}

.wy-post-editor-buttons {
  flex: 1 0 auto;
}

.wy-post-editor-text {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
}

.wy-post-editor-mention {
  background: blue;
  color: white;
}

.wy-post-editor-link {
  background: blue;
  color: white;
}

.wy-post-editor .ͼ1.cm-editor,
.wy-post-editor-grow::after,
.wy-post-editor-grow > textarea,
.wy-post-editor-textfield {
  flex: 1 1 100%;
  max-height: 11.25rem;
  min-height: 4rem;
  background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  border-radius: var(--wy-border-radius, 0.5rem);
  border: var(--wy-input-border-width, 1px) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  caret-color: var(--wy-primary, var(--wy-primary-40, #006399));
}
.wy-post-editor .ͼ1.cm-editor:focus,
.wy-post-editor-grow:focus::after,
.wy-post-editor-grow > textarea:focus,
.wy-post-editor-textfield:focus {
  border-color: var(--wy-primary, var(--wy-primary-40, #006399));
}

.wy-post-editor .ͼ1.cm-editor .cm-content,
.wy-post-editor-textcontent {
  font-family: var(--wy-input-font-family, var(--wy-font-family, inherit)), inherit;
  font-size: var(--wy-input-font-size, var(--wy-font-size-base, 1rem));
  padding: var(--wy-input-padding-y, 0.4375rem) var(--wy-input-padding-x, 0.75rem);
}

.wy-post-editor-grow {
  display: grid;
}
.wy-post-editor-grow::after,
.wy-post-editor-grow > textarea {
  grid-area: 1/1/2/2;
}
.wy-post-editor-grow::after {
  content: attr(data-replicated-value) " ";
  white-space: pre-wrap;
  visibility: hidden;
}
.wy-post-editor-grow > textarea {
  resize: none;
  overflow: hidden;
}

.wy-post-editor .ͼ1 .cm-scroller {
  font-family: unset;
  line-height: 1.5;
}
.wy-post-editor .ͼ1 .cm-widgetBuffer {
  vertical-align: unset;
}
.wy-post-editor .ͼ1 .cm-placeholder {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
}
.wy-post-editor .ͼ2 .cm-content {
  caret-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
}
.wy-post-editor .ͼ1.cm-editor.cm-focused {
  /* default theme in codemirror seems difficult to override */
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  color: var(--wy-component-color);
  border-color: var(--wy-primary, var(--wy-primary-40, #006399));
  outline: 0;
}
.wy-post-editor .ͼ1.cm-editor .cm-scroller {
  overflow: auto;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller {
  scrollbar-width: thin;
  scrollbar-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e)) transparent;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar {
  height: 0.625rem;
  width: 0.625rem;
  background: transparent;
  z-index: 999;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-track {
  background: transparent;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  border: 0.125rem solid transparent;
  border-radius: 0.5rem;
  background-clip: padding-box;
  opacity: 75%;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb:hover {
  background-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  opacity: 75%;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb:window-inactive {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  opacity: 50%;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-button:vertical:start:single-button {
  height: 0.375rem;
}
.wy-scrollbars .wy-post-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-button:vertical:end:single-button {
  height: 0.375rem;
}
.wy-post-editor .wy-is-invalid + [data-editor-target] .cm-editor, .wy-post-editor .wy-is-invalid .cm-editor {
  border-color: var(--wy-error, var(--wy-error-40, #ba1824)) !important;
}
.wy-post-editor .ͼ1 .cm-tooltip.cm-tooltip-autocomplete > ul {
  font-family: unset;
  max-height: 15rem;
}
.wy-post-editor .ͼ1 .cm-tooltip.cm-tooltip-autocomplete > ul > li {
  padding: 0;
}
.wy-post-editor .ͼ2 .cm-tooltip {
  border: none;
  background-clip: padding-box;
  background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  border-radius: var(--wy-border-radius, 0.5rem);
  box-shadow: var(--wy-shadow-level1, 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.14), 0 0.1875rem 0.0625rem -0.125rem rgba(0, 0, 0, 0.2), 0 0.0625rem 0.3125rem 0 rgba(0, 0, 0, 0.12));
  overflow: hidden;
  z-index: 1000;
}
.wy-post-editor .ͼ2 .cm-tooltip-autocomplete ul li[aria-selected] {
  background: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
  color: unset;
}
.wy-post-editor .cm-tooltip-autocomplete .cm-completionLabel {
  display: none;
}
.wy-post-editor .cm-tooltip-autocomplete .wy-item-hover:hover, .wy-post-editor .cm-tooltip-autocomplete .wy-item-hover:focus {
  background: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
}
.wy-post-editor .cm-tooltip-autocomplete .wy-avatar {
  width: 32px;
  height: 32px;
}

.wy-comments {
  padding: 0 1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.wy-comments-count {
  padding: 0 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wy-comment {
  --wy-component-background-color: var(--wy-surface-3, var(--wy-surface-3-light, #e3e7ee));
  --wy-component-color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  --wy-component-border-radius: var(--wy-border-radius, 0.5rem);
  border-radius: var(--wy-component-border-radius);
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.25rem;
  position: relative;
}
.wy-comment .wy-item {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.wy-comment .wy-item > .wy-avatar, .wy-comment .wy-item > wy-icon, .wy-comment .wy-item > .wy-icon-stack {
  margin-left: -0.25rem;
}
.wy-comment .wy-reactions-line {
  position: absolute;
  bottom: -1.125rem;
  right: 0.25rem;
}

.wy-comment-body {
  flex: 1 0 auto;
  z-index: 1;
}
.wy-comment-body .wy-image-grid, .wy-comment-body .wy-embed, .wy-comment-body .wy-content, .wy-comment-body .wy-list, .wy-comment-body .wy-poll {
  margin-bottom: 1rem;
}
.wy-comment-body .wy-image-grid:last-child, .wy-comment-body .wy-embed:last-child, .wy-comment-body .wy-content:last-child, .wy-comment-body .wy-list:last-child, .wy-comment-body .wy-poll:last-child {
  margin-bottom: 0;
}

.wy-comment-content {
  padding: 0 0.5rem 0.5rem;
  display: flex;
  flex-direction: column;
}

.wy-comment-editor .wy-spinner {
  display: none;
}
.wy-comment-editor.wy-uploading .wy-spinner {
  display: block;
}
.wy-comment-editor.wy-uploading [data-icon=plus] {
  display: none;
}
.wy-comment-editor .wy-picker-list:not(:empty) {
  border-top: 1px solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}

.wy-comment-editor-bottom {
  position: sticky;
  bottom: 0;
  z-index: 999;
  background-color: var(--wy-component-background-color);
  color: var(--wy-component-color);
}

.wy-comment-editor-inputs {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 0.5rem 0.25rem;
  min-height: 3.5rem;
}
.wy-comment-editor-inputs > :not(:last-child) {
  margin-right: 0.25rem;
}

.wy-comment-editor-buttons {
  flex: 1 0 auto;
}

.wy-comment-editor-text {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
}

.wy-comment-editor-mention {
  background: blue;
  color: white;
}

.wy-comment-editor-link {
  background: blue;
  color: white;
}

.wy-comment-editor .ͼ1.cm-editor,
.wy-comment-editor-grow::after,
.wy-comment-editor-grow > textarea,
.wy-comment-editor-textfield {
  flex: 1 1 100%;
  max-height: 11.25rem;
  background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  border-radius: 1.25rem;
  border: var(--wy-input-border-width, 1px) solid var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
}
.wy-comment-editor .ͼ1.cm-editor:focus,
.wy-comment-editor-grow:focus::after,
.wy-comment-editor-grow > textarea:focus,
.wy-comment-editor-textfield:focus {
  border-color: var(--wy-primary, var(--wy-primary-40, #006399));
}

.wy-comment-editor .ͼ1.cm-editor .cm-content,
.wy-comment-editor-textcontent {
  font-family: var(--wy-input-font-family, var(--wy-font-family, inherit)), inherit;
  font-size: var(--wy-input-font-size, var(--wy-font-size-base, 1rem));
  padding: var(--wy-input-padding-y, 0.4375rem) var(--wy-input-padding-x, 0.75rem);
}

.wy-comment-editor-grow {
  display: grid;
}
.wy-comment-editor-grow::after,
.wy-comment-editor-grow > textarea {
  grid-area: 1/1/2/2;
}
.wy-comment-editor-grow::after {
  content: attr(data-replicated-value) " ";
  white-space: pre-wrap;
  visibility: hidden;
}
.wy-comment-editor-grow > textarea {
  resize: none;
  overflow: hidden;
}

.wy-comment-editor {
  position: relative;
}
.wy-comment-editor .ͼ1 .cm-scroller {
  font-family: unset;
  line-height: 1.5;
}
.wy-comment-editor .ͼ1 .cm-widgetBuffer {
  vertical-align: unset;
}
.wy-comment-editor .ͼ1 .cm-placeholder {
  color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
}
.wy-comment-editor .ͼ2 .cm-content {
  caret-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
}
.wy-comment-editor .ͼ1.cm-editor.cm-focused {
  /* default theme in codemirror seems difficult to override */
  --wy-component-color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  color: var(--wy-component-color);
  border-color: var(--wy-primary, var(--wy-primary-40, #006399));
  outline: 0;
}
.wy-comment-editor .ͼ1.cm-editor .cm-scroller {
  overflow: auto;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller {
  scrollbar-width: thin;
  scrollbar-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e)) transparent;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar {
  height: 0.625rem;
  width: 0.625rem;
  background: transparent;
  z-index: 999;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-track {
  background: transparent;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  border: 0.125rem solid transparent;
  border-radius: 0.5rem;
  background-clip: padding-box;
  opacity: 75%;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb:hover {
  background-color: var(--wy-outline-variant, var(--wy-neutral-variant-80, #c2c7ce));
  opacity: 75%;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-thumb:window-inactive {
  background-color: var(--wy-outline, var(--wy-neutral-variant-50, #72777e));
  opacity: 50%;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-button:vertical:start:single-button {
  height: 0.375rem;
}
.wy-scrollbars .wy-comment-editor .ͼ1.cm-editor .cm-scroller::-webkit-scrollbar-button:vertical:end:single-button {
  height: 0.375rem;
}
.wy-comment-editor .wy-is-invalid + .cm-editor, .wy-comment-editor .wy-is-invalid .cm-editor {
  border-color: var(--wy-error, var(--wy-error-40, #ba1824)) !important;
}
.wy-comment-editor .ͼ1 .cm-tooltip.cm-tooltip-autocomplete > ul {
  font-family: unset;
  max-height: 15rem;
}
.wy-comment-editor .ͼ1 .cm-tooltip.cm-tooltip-autocomplete > ul > li {
  padding: 0;
}
.wy-comment-editor .ͼ2 .cm-tooltip {
  border: none;
  background-clip: padding-box;
  background-color: var(--wy-surface-2, var(--wy-surface-2-light, #eaedf3));
  color: var(--wy-on-surface, var(--wy-neutral-10, #1a1c1e));
  border-radius: var(--wy-border-radius, 0.5rem);
  box-shadow: var(--wy-shadow-level1, 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.14), 0 0.1875rem 0.0625rem -0.125rem rgba(0, 0, 0, 0.2), 0 0.0625rem 0.3125rem 0 rgba(0, 0, 0, 0.12));
  overflow: hidden;
  z-index: 1000;
}
.wy-comment-editor .ͼ2 .cm-tooltip-autocomplete ul li[aria-selected] {
  background: var(--wy-primary-container, var(--wy-primary-90, #cde5ff));
  color: unset;
}
.wy-comment-editor .cm-tooltip-autocomplete .cm-completionLabel {
  display: none;
}
.wy-comment-editor .cm-tooltip-autocomplete .wy-item-hover:hover, .wy-comment-editor .cm-tooltip-autocomplete .wy-item-hover:focus {
  background: var(--wy-surface-variant, var(--wy-neutral-variant-90, #dee3eb));
}
.wy-comment-editor .cm-tooltip-autocomplete .wy-avatar {
  width: 32px;
  height: 32px;
}

.wy-badge {
  display: inline-block;
  padding: 0.35em 0.65em;
  font-size: 0.75em;
  font-weight: var(--wy-font-weight-bold, );
  line-height: 1;
  color: var(--wy-on-primary, var(--wy-white, #ffffff));
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--wy-border-radius-pill, 50rem);
  background-color: var(--wy-primary, var(--wy-primary-40, #006399));
}
.wy-badge:empty {
  display: none;
}

.wy-button {
  position: relative;
}
.wy-button .wy-badge {
  font-size: var(--wy-font-size-xs, calc(0.75 * var(--wy-font-size-base, 1rem)));
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 1rem;
  margin: 0;
  padding: 0.25rem;
  min-width: 1rem;
  max-width: 2rem;
  height: 1rem;
  line-height: 0.5rem;
  display: block;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wy-button .wy-badge:empty {
  display: none;
}

.wy-conversations {
  position: relative;
}

.wy-conversation {
  display: flex;
  position: relative;
}
.wy-conversation .wy-item-title {
  font-weight: 400;
}
.wy-conversation.wy-unread .wy-item-title {
  font-weight: 700;
}
.wy-conversation.wy-unread .wy-item-text, .wy-conversation.wy-unread .wy-meta {
  color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  font-weight: 600;
}
.wy-conversation .wy-item-text .wy-typing-show {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
}

.wy-messenger-conversation {
  ---background-color: var(--wy-background, var(--wy-neutral-99, #fcfcff));
  ---color: var(--wy-on-background, var(--wy-neutral-10, #1a1c1e));
  background-color: var(---background-color);
  color: var(---color);
  overflow-anchor: none;
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  height: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
